webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fireBaseConfig__ = __webpack_require__(240);



var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp(__WEBPACK_IMPORTED_MODULE_2__fireBaseConfig__["a" /* default */]);

var firestore = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore();
var settings = { timestampsInSnapshots: true };
firestore.settings(settings);

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp.firestore());

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerName_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2be7e8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerName_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerName_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2be7e8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerName_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2be7e8c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerName_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App',
  components: {},
  data: function data() {
    return {
      fixed: false
    };
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ToolBar__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BrokerToolBar__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FreightSearch__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_InboxHelp__ = __webpack_require__(256);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'viewfreight',
  components: { toolbar: __WEBPACK_IMPORTED_MODULE_2__components_ToolBar__["a" /* default */], brokertoolbar: __WEBPACK_IMPORTED_MODULE_3__components_BrokerToolBar__["a" /* default */], brokerName: __WEBPACK_IMPORTED_MODULE_4__components_BrokerName__["a" /* default */], freightSearch: __WEBPACK_IMPORTED_MODULE_5__components_FreightSearch__["a" /* default */], help: __WEBPACK_IMPORTED_MODULE_6__components_InboxHelp__["a" /* default */] },
  data: function data() {
    return {
      shippingFreight: [],
      brokerFreight: [],
      shipments: [],
      show: false,
      selected: [2],
      isBroker: false,
      isShipper: true,
      receipt: false,
      mobile: '',
      txt: false,
      push: false,
      UserID: null,
      user: {},
      settings: false,
      showHelp: false,
      brokerID: '',
      showFreightSearch: false,
      dot: '/static/blueDot.png',
      phoneRules: [function (v) {
        return (/^$|^(\+\d{1,4})?[\s-]?\(?(\d{3})\)?[\s-]?\d{3}[\s-]?\d{4}/.test(v) || 'Mobile number must be valid'
        );
      }]
    };
  },
  firestore: function firestore() {
    return {};
  },

  mounted: function mounted() {
    var _this = this;

    this.$bind('user', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid)).then(function (doc) {
      _this.mobile = _this.user.mobile;
      _this.push = _this.user.sendPush;
      _this.receipt = _this.user.sendReceipt;
      _this.txt = _this.user.sendSMS;
      _this.userID = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
      if (_this.user.isBroker) {
        _this.isBroker = true;
        _this.isShipper = false;
        _this.brokerID = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
        _this.$bind('shipments', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').where('brokers.' + __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid, '==', true).where('isActive', '==', true));
      } else {
        // brokerID generic for all id's
        _this.brokerID = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
        _this.isBroker = false;
        _this.isShipper = true;
        _this.$bind('shipments', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').where('Shipper', '==', __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid).where('isActive', '==', true));
      }
    });
  },
  methods: {
    enablePush: function enablePush() {
      if (!this.user.sendPush) {
        var messaging = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.messaging();
        messaging.usePublicVapidKey('BCAgktL2vpb0hNNKITygLDrNcS3YwVk28-oRtw4tmU4Qm7G65nmJ1zHOX78ktmxfLQLEeRSvb03u0FpVW_QNgn8');

        messaging.requestPermission().then(function () {
          console.log('Notification permission granted.');
          messaging.getToken().then(function (currentToken) {
            if (currentToken) {
              console.log(currentToken);
              var update = {};
              update['token'] = currentToken;
              __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid).update(update);
              // sendTokenToServer(currentToken)
              // updateUIForPushEnabled(currentToken)
            } else {
              // Show permission request.
              console.log('No Instance ID token available. Request permission to generate one.');
              // Show permission UI.
              // updateUIForPushPermissionRequired()
              // setTokenSentToServer(false)
            }
          }).catch(function (err) {
            console.log('An error occurred while retrieving token. ', err);
            // showToken('Error retrieving Instance ID token. ', err)
            // setTokenSentToServer(false)
          });
        }).catch(function (err) {
          console.log('Unable to get permission to notify.', err);
        });
      } else {
        // Remove the token from firebaes
        __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid).update({ token: null });
      }
    },
    updatePhone: function updatePhone() {
      this.settings = false;
      var update = {};
      update['mobile'] = this.mobile;
      update['sendPush'] = this.push;
      update['sendReceipt'] = this.receipt;
      update['sendSMS'] = this.txt;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid).update(update);
    },
    toggle: function toggle(index) {
      if (!this.isBroker) {
        // this.$router.push('freight' + '/' + index)
        this.$router.push({ name: 'shipperfreight', params: { shipmentID: index } });
      } else {
        // this.$router.push('brokerfreight' + '/' + index)
        this.$router.push({ name: 'brokerfreight', params: { shipmentID: index, brokerID: this.brokerID } });
      }
    },

    showShippers: function showShippers() {
      console.log(this.brokerID);
      this.$router.push({ name: 'shippers', params: { brokerID: this.brokerID } });
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().signOut().then(function () {
        _this2.$router.replace('/');
      });
    }
  },
  watch: {},
  computed: {}
});

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar',
  data: function data() {
    return {
      user: '',
      drawer: false,
      items: [{
        href: 'viewfreight',
        router: true,
        title: 'View Freight',
        icon: 'local_shipping'
      }, {
        href: 'brokers',
        router: true,
        title: 'Brokers',
        icon: 'account_circle'
      }, {
        href: 'newfreight',
        router: true,
        title: 'New Freight',
        icon: 'add'
      }]
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
        _this.$router.replace('/');
      });
    }
  },
  firestore: function firestore() {
    var userId = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid;
    return {
      user: __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(userId)
    };
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar',
  data: function data() {
    return {
      user: '',
      drawer: false,
      items: [{
        href: 'viewfreight',
        router: true,
        title: 'View Freight',
        icon: 'local_shipping'
      }]
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
        _this.$router.replace('/');
      });
    }
  },
  firestore: function firestore() {
    var userId = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid;
    return {
      user: __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(userId)
    };
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      broker: {}
    };
  },

  props: ['brokerID'],
  firestore: function firestore() {
    return {};
  },

  watch: {
    brokerID: function brokerID() {
      this.$bind('broker', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(this.brokerID)).then(function (doc) {
        return null;
      }).catch(function (error) {
        console.log('error in loading: ', error);
      });
    }
  },
  mounted: function mounted() {
    this.$bind('broker', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(this.brokerID)).then(function (doc) {
      // do nothing special
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  computed: {
    fullname: function fullname() {
      return this.broker.username;
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_BrokerName__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FreightSearch',
  props: ['id', 'isBroker'],
  components: { brokerName: __WEBPACK_IMPORTED_MODULE_2__components_BrokerName__["a" /* default */] },
  data: function data() {
    return {
      shipments: {}
    };
  },

  methods: {
    toggle: function toggle(shipmentID) {
      this.$emit('cargo', shipmentID);
    }
  },
  computed: {
    getShipment: function getShipment() {
      if (this.isBroker) {
        console.log('broker');
        this.$bind('shipments', __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').where('brokers.' + __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid, '==', true).where('isActive', '==', false)).then(function (doc) {
          return true;
        });
      } else {
        console.log('shipper');
        this.$bind('shipments', __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').orderBy('PickupDate', 'desc').where('Shipper', '==', __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid).where('isActive', '==', false)).then(function (doc) {
          return true;
        });
      }
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: 'fiber_new', iconClass: 'red--text darken-4', title: 'New Messages', subtitle: 'You have a new message.' }, { icon: 'check_circle', iconClass: 'blue--text darken-4', title: 'Tendered', subtitle: 'Shipment has been tendered.' }, { icon: 'exit_to_app', iconClass: 'teal', title: 'Logout', subtitle: 'Logout of Kangaruu.' }, { icon: 'account_circle', iconClass: 'teal', title: 'Show Brokers/Shippers', subtitle: 'Manage your relationships.' }, { icon: 'add', iconClass: 'teal', title: 'New Shipment', subtitle: 'Create a new shipment.' }, { icon: 'settings', iconClass: 'teal', title: 'Settings', subtitle: 'Set-up user settings and notifications.' }, { icon: 'search', iconClass: 'teal', title: 'Search Shipments', subtitle: 'Locate old shipments.' }, { icon: 'keyboard_backspace', iconClass: 'teal', title: 'Go Back', subtitle: 'Return to previous screen.' }]

    };
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pickup__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoogleMap__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Help__ = __webpack_require__(285);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

  components: { Pickup: __WEBPACK_IMPORTED_MODULE_2__pickup__["a" /* default */], googleMap: __WEBPACK_IMPORTED_MODULE_3__GoogleMap__["a" /* default */], brokerName: __WEBPACK_IMPORTED_MODULE_6__BrokerName__["a" /* default */], help: __WEBPACK_IMPORTED_MODULE_7__components_Help__["a" /* default */] },

  name: 'newfreight',
  data: function data() {
    return {
      address: '',
      pickupAddresses: [],
      deliveryAddresses: [],
      pickupDate: null,
      deliveryDate: null,
      e1: 1,
      truck: 'OTR',
      options: [],
      c1: 'teal',
      chips: [],
      date: null,
      menu: null,
      freight: null,
      user: {},
      brokers: [],
      showBrokers: false,
      showHelp: false,
      city: ''
    };
  },
  firestore: function firestore() {
    return {};
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    this.$bind('user', __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid)).then(function (doc) {
      var moment = __webpack_require__(0);
      var date = moment().add(1, 'days');
      _this.pickupDate = moment(date).format('YYYY-MM-DD');
      _this.deliveryDate = moment(date).format('YYYY-MM-DD');
      for (var brokerKey in _this.user.brokers) {
        _this.brokers.push(brokerKey);
      }
    });
  },
  methods: {
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = addressData;
      if (this.address) {
        this.chips.push(this.address.locality + ', ' + this.address.postal_code);
      }
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signOut().then(function () {
        _this2.$router.replace('/');
      });
    },
    chipColor: function chipColor(chip) {
      if (chip) {
        switch (chip.substring(0, chip.indexOf(':'))) {
          case 'Pickup':
            return 'teal';
          case 'PickupDate':
            return 'teal';
          case 'Freight':
            return 'red';
          case 'Options':
            return 'orange';
          case 'Equipment':
            return 'black';
          case 'Delivery':
            return 'blue';
          case 'DeliveryDate':
            return 'blue';
          case 'Miles':
            return 'purple';
          default:
            return 'black';
        }
      } else {
        return 'black';
      }
    },
    remove: function remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1);
      this.chips = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.chips));
      // Todo remove from addresses if devivery
    },
    getCity: function getCity(city) {
      this.city = city;
    },
    newCargo: function newCargo(cargo) {
      if (cargo) {
        this.chips.push(cargo);
        var value = cargo.substring(cargo.indexOf(':') + 2, cargo.length);
        switch (cargo.substring(0, cargo.indexOf(':'))) {
          case 'PickupDate':
            this.pickupDate = value;
            this.deliveryDate = this.pickupDate;
            break;
          case 'DeliveryDate':
            this.deliveryDate = value;
            break;
          case 'Pickup':
            this.pickupAddresses.push(value);
            break;
          case 'Delivery':
            this.deliveryAddresses.push(value);
            break;
        }
      }
    },
    addDate: function addDate(newDate) {
      if (typeof newDate !== 'undefined' && newDate) {
        console.log(newDate);

        for (var i = 0; i < this.chips.length; i++) {
          var str = this.chips[i];
          var n = str.indexOf(':');
          var key = str.substring(0, n);
          if (key === 'Pickup') {
            this.remove(i);
          }
          if (key === 'Delivery') {
            this.remove(i);
          }
        }
        for (var _i = 0; _i < newDate.length; _i++) {
          this.newCargo('Delivery: ' + newDate[_i][0]);
        }
        var miles = newDate[newDate.length - 1][1];
        this.chips.push('Miles: ' + miles.substring(0, miles.length - 2));
        var seconds = newDate[newDate.length - 1][3];
        var oneSecond = 0.000277778;
        var hours = seconds * oneSecond;
        var days = hours / 11;
        var moment = __webpack_require__(0);
        var date = moment(this.pickupDate).add(days, 'days');
        this.deliveryDate = moment(date).format('YYYY-MM-DD');
      }
    },
    addEquipment: function addEquipment() {
      if (typeof this.truck !== 'undefined' && this.truck) {
        this.chips.push('Equipment: ' + this.truck);
      } else {
        this.chips.push('Equipment: ' + 'None');
      }
      this.e1++;
    },
    addFreight: function addFreight(move) {
      if (typeof this.freight !== 'undefined' && this.freight) {
        this.chips.push('Freight: ' + this.freight);
      }
      if (move) {
        this.e1++;
      } else {
        this.freight = '';
        this.$refs.freight.focus();
      }
    },
    addOptions: function addOptions(move) {
      if (typeof this.options !== 'undefined' && this.options) {
        this.chips.push('Options: ' + this.options);
      } else {
        this.chips.push('Options: ' + 'None');
      }
      if (move) {
        this.showBrokers = false;
        this.updateFireStore(this.chips);
        this.$router.push('/viewfreight');
      } else {
        this.options = '';
        this.$refs.options.focus();
      }
    },
    guid: function guid() {
      function _p8(s) {
        var p = (Math.random().toString(16) + '00000000').substr(2, 6);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
      }
      return _p8();
    },
    updateFireStore: function updateFireStore(chips) {
      var _this3 = this;

      var n = '';
      var str = '';
      var key = '';
      var val = '';
      var shipment = {};
      var pickup = [];
      var freight = [];
      var delivery = [];
      var options = [];
      var brokerList = {};
      this.chips.sort();
      shipment['Reference'] = this.guid();

      for (var i = 0; i < this.chips.length; i++) {
        str = this.chips[i];
        n = str.indexOf(':');
        key = str.substring(0, n);
        val = str.substring(n + 2, str.length);
        console.log(key);
        if (key === 'Pickup') {
          pickup.push(val);
        } else if (key === 'Freight') {
          freight.push(val);
        } else if (key === 'Delivery') {
          delivery.push(val);
        } else if (key === 'Options') {
          options.push(val);
        } else {
          shipment[key] = val;
        }
        shipment['Pickup'] = pickup;
        shipment['Freight'] = freight;
        shipment['Delivery'] = delivery;
        shipment['Options'] = options;
        shipment['Shipper'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
        shipment['isActive'] = true;
        shipment['created'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()().unix();
        if (this.city) {
          shipment['City'] = this.city;
        } else {
          shipment['City'] = 'Unknown';
        }
      }
      for (var _i2 = 0; _i2 < this.brokers.length; _i2++) {
        brokerList[this.brokers[_i2]] = true;
      }
      console.log(brokerList);
      shipment['brokers'] = brokerList;
      shipment['newMessages'] = brokerList;
      // db.collection('freight').add({ shipment }) <--makes on object
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').add(shipment).then(function (snap) {
        // start the conversation record
        var con = {};
        con['created'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()().unix();
        con['shipper'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
        __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(snap.id).set(con);
        // Send all brokers a message
        var msg = {};
        var quote = {};
        msg['message'] = 'Please Quote this Shipment';
        msg['sender'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
        msg['created'] = __WEBPACK_IMPORTED_MODULE_5_moment___default()().unix();
        for (var brokerKey in brokerList) {
          // console.log(snap.id + 'freight')
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(snap.id).collection('brokers').doc(brokerKey).collection('messages').add(msg);
          quote['quote'] = '$0';
          quote['status'] = 'New';
          quote['selected'] = false;
          quote['isActive'] = true;
          quote['shipper'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(snap.id).collection('brokers').doc(brokerKey).set(quote);
        }
        // ok Lets send some texts and push
        var sms = {};
        var push = {};
        for (brokerKey in brokerList) {
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(brokerKey).get().then(function (snap) {
            console.log(snap.data().sendSMS);
            if (snap.data().sendSMS) {
              sms['phoneNumber'] = snap.data().mobile;
              sms['company'] = _this3.user.company;
              sms['messageType'] = 'Freight Quote';
              console.log(sms);
              __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('sms').add(sms);
            }
            if (snap.data().sendPush) {
              push['sendTo'] = snap.id;
              __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('push').add(push);
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_autocomplete__ = __webpack_require__(278);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {},

  components: { VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_0__vue_autocomplete__["a" /* default */] },
  name: 'pickup',
  data: function data() {
    return {
      date: null,
      menu: null
    };
  },

  props: ['pickupType', 'deliveryDate'],
  firestore: function firestore() {
    return {};
  },

  watch: {
    deliveryDate: function deliveryDate() {
      this.date = this.deliveryDate;
    }
  },
  methods: {
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = placeResultData;
      this.$emit('cargo', this.pickupType + ': ' + this.address.formatted_address);
      if (this.pickupType === 'Delivery') {
        this.$emit('city', addressData.locality);
      }
    },
    clearField: function clearField() {
      this.$refs.address.clear();
      this.$refs.address.focus();
    },
    nextStep: function nextStep() {
      this.$emit('cargo', this.pickupType + 'Date: ' + this.date);
      this.$emit('nextStep');
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  /* global google */
  name: 'VueGoogleAutocomplete',
  props: {
    id: {
      type: String,
      required: true
    },
    classname: String,
    placeholder: {
      type: String,
      default: 'Start typing'
    },
    types: {
      type: String,
      default: ''
    },
    label: {
      label: String
    },
    country: {
      type: [String, Array],
      default: null
    },
    enableGeolocation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      /**
                                           * The Autocomplete object.
                                           *
                                           * @type {Autocomplete}
                                           * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
                                           */
      autocomplete: null,
      /**
                                           * Autocomplete input text
                                           * @type {String}
                                           */
      autocompleteText: ''
    };
  },
  watch: {
    autocompleteText: function autocompleteText(newVal, oldVal) {
      this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
    },
    country: function country(newVal, oldVal) {
      this.autocomplete.setComponentRestrictions({
        country: this.country === null ? [] : this.country
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    var options = {};
    if (this.types) {
      options.types = [this.types];
    }
    if (this.country) {
      options.componentRestrictions = {
        country: this.country
      };
    }
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);
    this.autocomplete.addListener('place_changed', function () {
      var place = _this.autocomplete.getPlace();
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        _this.$emit('no-results-found', place, _this.id);
        return;
      }
      var addressComponents = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'county',
        country: 'long_name',
        postal_code: 'short_name'
      };
      var returnData = {};
      if (place.address_components !== undefined) {
        // Get each component of the address from the place details
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (addressComponents[addressType]) {
            var val = place.address_components[i][addressComponents[addressType]];
            returnData[addressType] = val;
          }
        }
        // console.log(place.formatted_address)
        _this.autocompleteText = place.formatted_address;
        returnData['latitude'] = place.geometry.location.lat();
        returnData['longitude'] = place.geometry.location.lng();
        // update autocompleteText then emit change event
        // this.autocompleteText = document.getElementById(this.id).value
        _this.onChange();
        // return returnData object and PlaceResult object
        _this.$emit('placechanged', returnData, place, _this.id);
      }
    });
  },
  methods: {
    /**
                             * When the input gets focus
                             */
    onFocus: function onFocus() {
      this.geolocate();
      this.$emit('focus');
    },

    /**
                             * When the input loses focus
                             */
    onBlur: function onBlur() {
      this.$emit('blur');
    },

    /**
                             * When the input got changed
                             */
    onChange: function onChange() {
      this.$emit('change', this.autocompleteText);
    },

    /**
                             * When a key gets pressed
                             * @param  {Event} event A keypress event
                             */
    onKeyPress: function onKeyPress(event) {
      this.$emit('keypress', event);
    },

    /**
                             * When a keyup occurs
                             * @param  {Event} event A keyup event
                             */
    onKeyUp: function onKeyUp(event) {
      this.$emit('keyup', event);
    },

    /**
                             * Clear the input
                             */
    clear: function clear() {
      this.autocompleteText = '';
    },

    /**
                             * Focus the input
                             */
    focus: function focus() {
      this.$refs.autocomplete.focus();
    },

    /**
                             * Blur the input
                             */
    blur: function blur() {
      this.$refs.autocomplete.blur();
    },

    /**
                             * Update the value of the input
                             * @param  {String} value
                             */
    update: function update(value) {
      this.autocompleteText = value;
    },

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate: function geolocate() {
      var _this2 = this;

      if (this.enableGeolocation) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            var geolocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            var circle = new google.maps.Circle({
              center: geolocation,
              radius: position.coords.accuracy
            });
            _this2.autocomplete.setBounds(circle.getBounds());
          });
        }
      }
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  /* global google */
  name: 'google-map',
  data: function data() {
    return {
      distance: null,
      travelTime: null
    };
  },

  props: ['pickupDate', 'deliveryDate', 'pickupAddresses', 'deliveryAddresses'],
  mounted: function mounted() {},
  methods: {
    calculateDistances: function calculateDistances() {
      var service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix({
        origins: this.pickupAddresses,
        destinations: this.deliveryAddresses,
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        drivingOptions: { departureTime: new Date(Date.now()), trafficModel: 'optimistic' },
        avoidHighways: false,
        avoidTolls: false
      }, this.callback);
    },
    callback: function callback(response, status) {
      if (status !== google.maps.DistanceMatrixStatus.OK) {
        alert('Error was: ' + status);
      } else {
        var routes = response.rows[0];
        var sortable = [];
        var resultText = 'Origin: <b>' + this.pickupAddresses + '</b><br/>';
        resultText += 'Possible Routes: <br/>';
        for (var i = routes.elements.length - 1; i >= 0; i--) {
          var rteLength = routes.elements[i].distance.text;
          var rteTime = routes.elements[i].duration.text;
          var rteSeconds = routes.elements[i].duration.value;
          resultText += 'Route: <b>' + this.deliveryAddresses[i] + '</b>, ' + 'Route Length: <b>' + rteLength + '</b><br/>';
          sortable.push([this.deliveryAddresses[i], rteLength, rteTime, rteSeconds]);
        }
        // sort the result lengths from shortest to longest.
        sortable.sort(function (a, b) {
          return a[1] - b[1];
        });
        // build the waypoints.
        var waypoints = [];
        for (var j = 0; j < sortable.length - 1; j++) {
          waypoints.push({
            location: sortable[j][0],
            stopover: true
          });
        }
        console.log(resultText);
        this.distance = sortable[0][1];
        this.travelTime = sortable[0][2];
        this.$emit('newDate', sortable);
      }
    }
  }
});

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: 'add', iconClass: 'blue', title: 'Add', subtitle: 'Add additional items.' }, { icon: 'check', iconClass: 'teal', title: 'OK', subtitle: 'Add item and move to next.' }, { icon: 'access_time', iconClass: 'orange', title: 'Get Distance', subtitle: 'Calculate distane and generate delivery date.' }]
    };
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WayBill__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AddBrokers__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileUploader__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_to_image__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_to_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_print_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_print_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_DetailHelp__ = __webpack_require__(205);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'freightdetail',
  props: ['shipmentID'],
  components: { waybill: __WEBPACK_IMPORTED_MODULE_2__WayBill__["a" /* default */], brokerName: __WEBPACK_IMPORTED_MODULE_3__BrokerName__["a" /* default */], addBrokers: __WEBPACK_IMPORTED_MODULE_5__AddBrokers__["a" /* default */], fileUploader: __WEBPACK_IMPORTED_MODULE_6__FileUploader__["a" /* default */], help: __WEBPACK_IMPORTED_MODULE_10__components_DetailHelp__["a" /* default */] },
  data: function data() {
    return {
      shipment: {},
      googleUrl: null,
      title: null,
      brokers: [],
      warnDialog: false,
      brokerDialog: false,
      user: {},
      freightID: '',
      showImage: false,
      imageURL: '',
      fileList: [],
      uploading: false,
      bytes: 0,
      snackbar: false,
      editor: false,
      instructions: '',
      brokerID: '',
      showHelp: false,
      showWaybill: false
    };
  },

  watch: {
    brokers: function brokers() {
      this.getSelectedBroker();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$bind('shipment', __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.shipmentID)).then(function (doc) {
      if (doc.Shipper === __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid) {
        _this.freightID = _this.shipmentID;
        _this.getMap();
        _this.clearMessageFlag();
        _this.imageURL = _this.shipment.BOL;
        _this.instructions = _this.shipment.Instructions;
        _this.getSelectedBroker();
      } else {
        alert('Cannot Access this Shipment');
        _this.shipment = 'Invalid';
        _this.freightID = 'Invalid';
      }
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  methods: {
    print: function print() {
      __WEBPACK_IMPORTED_MODULE_9_print_js___default()({ printable: 'my-node', type: 'html', documentTitle: 'Kangaruu - Shipping Instructions' });
    },
    changeBytes: function changeBytes(bytes) {
      console.log(bytes);
      this.bytes = bytes;
    },
    uploadDone: function uploadDone() {
      this.uploading = false;
      this.snackbar = true;
    },
    calculateRate: function calculateRate(quote, miles) {
      var nQuote = 0;
      var nMiles = 0;
      if (quote != null) {
        nQuote = parseFloat(quote.replace(/[$,]+/g, ''));
      }
      if (miles != null) {
        nMiles = parseFloat(miles.replace(/[$,]+/g, ''));
      }
      // console.log(quote, nQuote, nMiles)
      var currentRate = 2.75;
      var avgRate = currentRate * nMiles;
      var rateDiff = avgRate - nQuote;
      // console.log(rateDiff)
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      var rateDiffString = formatter.format(rateDiff);
      // console.log(avgRate, rateDiff, nQuote)
      if (avgRate >= nQuote && nQuote > 0 && nMiles > 0) {
        return rateDiffString + ' below market rate.';
      } else if (avgRate < nQuote && nQuote > 0 && nMiles > 0) {
        return rateDiffString + ' above market rate.';
      }
    },
    getMap: function getMap() {
      this.title = 'Shipment: ' + this.shipment.Reference;
      console.log(this.shipment.Delivery);
      if (typeof this.shipment !== 'undefined' && this.shipment) {
        var start = this.shipment.Pickup[0];
        var end = this.shipment.Delivery[this.shipment.Delivery.length - 1];
        var points = '';
        for (var i = 1; i < this.shipment.Pickup.length; i++) {
          var str = this.shipment.Pickup[i];
          points = points + str.replace(/ /g, '+') + '| ';
        }
        for (var _i = 0; _i < this.shipment.Delivery.length; _i++) {
          var _str = this.shipment.Delivery[_i];
          points = points + _str.replace(/ /g, '+') + '| ';
        }
        points = points.substring(0, points.length - 2);

        this.googleUrl = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyCw3FKI8Eh1SY6rfwJkba1LL3Aetx9RrvI&origin=' + start + '&destination=' + end + '&waypoints=' + points;
      }
    },
    onPickFile: function onPickFile() {
      this.$refs.imageUpload.click();
    },
    detectFiles: function detectFiles(fileList) {
      var _this2 = this;

      this.uploading = true;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        _this2.fileList = fileList[x];
      });
    },

    removeShipment: function removeShipment() {
      this.warnDialog = false;
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update({ isActive: false });
      // db.collection('conversations').doc(this.$route.params.id).delete()
      this.$router.replace({ path: '/viewfreight' });
    },
    getSelectedBroker: function getSelectedBroker() {
      for (var brokerKey in this.shipment.brokers) {
        this.loadBrokerData(brokerKey);
      }
    },
    loadBrokerData: function loadBrokerData(brokerKey) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).get().then(function (snap) {
        if (snap.data().selected) {
          _this3.brokerID = brokerKey;
          console.log('selected Broker:', _this3.brokerID);
        }
      });
    },

    selectBrokers: function selectBrokers(brokerID, selected) {
      var _this4 = this;

      var message = {};
      var update = {};
      console.log(brokerID, selected);
      for (var brokerKey in this.shipment.brokers) {
        console.log(brokerKey);
        if (brokerKey === brokerID && selected) {
          this.brokerID = brokerKey;
          // send a push
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(brokerKey).get().then(function (snap) {
            if (snap.data().sendPush) {
              __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('push').add({ sendTo: '' + _this4.brokerID });
            }
          });
          update['selected'] = true;
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).update(update);
          message['message'] = 'Ready to ship, please arrange a pickup.';
          message['sender'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
          message['created'] = __WEBPACK_IMPORTED_MODULE_7_moment___default()().unix();
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).collection('messages').add(message);
        } else {
          this.revokeFreight(brokerKey);
          update['selected'] = false;
          __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).update(update);
        }
      }
      // update freight Record
      var brokerList = {};
      var shipment = {};
      for (brokerKey in this.shipment.brokers) {
        if (brokerKey === brokerID) {
          brokerList[brokerKey] = selected;
        } else {
          brokerList[brokerKey] = false;
        }
      }
      shipment['isSelected'] = brokerList;
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(shipment);
    },
    revokeFreight: function revokeFreight(brokerID) {
      var _this5 = this;

      var message = {};
      console.log('they are the smame');
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).get().then(function (snap) {
        if (snap.data().isSelected) {
          console.log(brokerID, snap.data().isSelected[brokerID]);
          if (snap.data().isSelected[brokerID]) {
            message['message'] = 'Tender Revoked';
            message['sender'] = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid;
            message['created'] = __WEBPACK_IMPORTED_MODULE_7_moment___default()().unix();
            console.log('revoked');
            __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(_this5.freightID).collection('brokers').doc(brokerID).collection('messages').add(message);
          }
        }
      });
    },
    sendInstructions: function sendInstructions(email) {
      var _this6 = this;

      var id = this.freightID;
      var shipment = {};
      var vm = this;
      shipment['Instructions'] = this.instructions;
      if (this.instructions) {
        __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(shipment).then(function (snap) {
          _this6.editor = false;
          // Send summary email
          if (email) {
            vm.showWaybill = true;
            vm.$nextTick(function () {
              var node = document.getElementById('my-node');
              __WEBPACK_IMPORTED_MODULE_8_dom_to_image___default.a.toBlob(node).then(function (dataUrl) {
                var storageRef = __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage().ref();
                var uploadTask = storageRef.child(id + '/' + 'instructions.png').put(dataUrl);

                uploadTask.on('state_changed', function (snapshot) {
                  // Observe state change events such as progress, pause, and resume
                  // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                  this.progressUpload = snapshot.bytesTransferred / snapshot.totalBytes * 100;
                  console.log('Upload is ' + this.progressUpload + '% done');
                  switch (snapshot.state) {
                    case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.PAUSED:
                      // or 'paused'
                      console.log('Upload is paused');
                      break;
                    case __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.storage.TaskState.RUNNING:
                      // or 'running'
                      console.log('Upload is running');
                      break;
                  }
                }, function (error) {
                  // Handle unsuccessful uploads
                  console.log(error);
                }, function () {
                  // Handle successful uploads on complete
                  console.log(uploadTask.snapshot);
                  vm.showWaybill = false;
                  // Ok Now send Receipts
                  if (vm.user.sendReceipt) {
                    __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('receipt').add({ sendTo: '' + vm.user.email, sendDoc: '' + vm.freightID });
                    console.log('send Receipt Sender');
                  }
                  var receipt = {};
                  var push = {};
                  console.log(vm.brokerID);
                  __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(vm.brokerID).get().then(function (snap) {
                    if (snap.data().sendReceipt) {
                      receipt['sendTo'] = snap.data().email;
                      receipt['sendDoc'] = vm.freightID;
                      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('receipt').add(receipt);
                      console.log('send Receipt Broker');
                    }
                    if (snap.data().sendPush) {
                      push['sendTo'] = snap.id;
                      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('push').add(push);
                      console.log('send Push Broker');
                    }
                  });
                });
              });
            });
          }
        });
      }
    },
    downLoadFile: function downLoadFile() {
      var fileName = this.shipment.File;
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' });
        console.log(xhr.response);
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        // Create a DOMString representing the blob
        // and point the link element towards it
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        // programatically click the link to trigger the download
        a.click();
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      };
      xhr.open('GET', this.shipment.BOL);
      xhr.send();
    },

    showBroker: function showBroker(brokerID) {
      // this.$router.push('/broker' + '/' + brokerID)
      this.$router.push({ name: 'brokerdetail', params: { brokerID: brokerID, freightID: this.freightID } });
    },
    logout: function logout() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().signOut().then(function () {
        _this7.$router.replace('/');
      });
    },
    clearMessageFlag: function clearMessageFlag() {
      var userList = {};
      userList = this.shipment.newMessages;
      var messages = {};
      userList[this.shipment.Shipper] = false;
      messages['newMessages'] = userList;
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(messages);
    }
  },
  firestore: function firestore() {
    return {
      brokers: __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('conversations').doc(this.shipmentID).collection('brokers').where('isActive', '==', true),
      user: __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_4_firebase___default.a.auth().currentUser.uid)
      // add this for security .where('shipper', '==', 'firebase.auth().currentUser.uid')
    };
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WayBill_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734ac54b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WayBill_vue__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WayBill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734ac54b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WayBill_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_734ac54b_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WayBill_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrokerName__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'waybill',
  data: function data() {
    return {
      shipment: {},
      quotes: {}
    };
  },

  props: ['freightID', 'isBroker', 'brokerID'],
  components: { brokerName: __WEBPACK_IMPORTED_MODULE_1__BrokerName__["a" /* default */] },
  mounted: function mounted() {
    if (typeof this.brokerID !== 'undefined' && this.brokerID) {
      this.$bind('quotes', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID)).then(function (doc) {
        // do nothing special
      }).catch(function (error) {
        console.log('error in loading: ', error);
      });
    }
  },
  watch: {
    brokerID: function brokerID() {
      this.$bind('quotes', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID)).then(function (doc) {
        return null;
      }).catch(function (error) {
        console.log('error in loading: ', error);
      });
    }
  },
  methods: {},
  firestore: function firestore() {
    return {
      shipment: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID)
    };
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { brokerName: __WEBPACK_IMPORTED_MODULE_5__BrokerName__["a" /* default */], toolbar: toolbar },
  props: ['freightID'],
  name: 'addBrokers',
  data: function data() {
    return {
      newBrokers: [],
      selectedBroker: [],
      brokers: [],
      user: {},
      shipment: {},
      headers: [{
        text: 'Brokers',
        align: 'left',
        sortable: true,
        value: false
      }, { text: 'Company', value: false }]
    };
  },
  firestore: function firestore() {
    return {
      shipment: __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID),
      user: __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().currentUser.uid)
    };
  },

  mounted: function mounted() {
    var _this = this;

    this.$bind('brokers', __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('users').where('isBroker', '==', true)).then(function (doc) {
      _this.updateBrokers();
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  methods: {
    addBrokers: function addBrokers() {
      var _this2 = this;

      if (this.selectedBroker.length > 0) {
        var brokerList = {};
        for (var i = 0; i < this.selectedBroker.length; i++) {
          brokerList[this.selectedBroker[i].id] = true;
        }
        // update new brokers
        var msg = {};
        var quote = {};
        msg['message'] = 'Please Quote this Shipment';
        msg['sender'] = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().currentUser.uid;
        msg['created'] = __WEBPACK_IMPORTED_MODULE_7_moment___default()().unix();

        for (var brokerKey in brokerList) {
          __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).collection('messages').add(msg);
          quote['quote'] = '$0';
          quote['status'] = 'New';
          quote['selected'] = false;
          quote['isActive'] = true;
          __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(brokerKey).set(quote);
        }

        // update broker NewMessage
        var userList = this.shipment.newMessages;
        var messages = {};
        for (brokerKey in brokerList) {
          userList[brokerKey] = true;
        }
        messages['newMessages'] = userList;
        __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(messages);

        // ok Lets send some texts and push
        var sms = {};
        var push = {};
        for (brokerKey in brokerList) {
          __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('users').doc(brokerKey).get().then(function (snap) {
            console.log(snap.data().sendSMS);
            if (snap.data().sendSMS) {
              sms['phoneNumber'] = snap.data().mobile;
              sms['company'] = _this2.user.company;
              sms['messageType'] = 'Freight Quote';
              console.log(sms);
              __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('sms').add(sms);
            }
            if (snap.data().sendPush) {
              push['sendTo'] = snap.id;
              __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('push').add(push);
            }
          });
        }

        // update broker list
        for (var key in this.shipment.brokers) {
          brokerList[key] = true;
        }
        var brokerObj = { brokers: brokerList };
        __WEBPACK_IMPORTED_MODULE_4__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(brokerObj);
      }
      this.$emit('closeBroker');
    },
    buildMap: function buildMap(obj) {
      // used to get values out of an Object
      var map = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
        map.set(key, obj[key]);
      });
      return map;
    },
    updateBrokers: function updateBrokers() {
      if (this.brokers.length > 0) {
        this.newBrokers = this.brokers.slice();
        var brokerMap = this.buildMap(this.shipment.brokers);

        for (var i = 0; i < this.newBrokers.length; i++) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(brokerMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _ref = _step.value;

              var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

              var key = _ref2[0];
              var value = _ref2[1];

              if (this.newBrokers[i].id === key && value) {
                this.newBrokers.splice(i, 1);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        this.showBrokers = true;
      }
    }
  }
});

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fireBaseInit__ = __webpack_require__(3);

//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: '',
      downloadURL: '',
      uploading: false,
      snackbar: false
    };
  },

  props: ['freightID', 'fileList'],
  components: {},
  methods: {
    detectFiles: function detectFiles(fileList) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(fileList.length).keys()).map(function (x) {
        _this.uploadFile(fileList[x]);
      });
    },
    uploadFile: function uploadFile(file) {
      var vm = this;
      var storageRef = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage().ref();
      var id = this.freightID;
      console.log(this.freightID);
      var uploadTask = storageRef.child(this.freightID + '/' + file.name).put(file);

      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        this.progressUpload = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        console.log('Upload is ' + this.progressUpload + '% done');
        vm.$emit('bytes', this.progressUpload);
        switch (snapshot.state) {
          case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.PAUSED:
            // or 'paused'
            console.log('Upload is paused');
            break;
          case __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.storage.TaskState.RUNNING:
            // or 'running'
            console.log('Upload is running');
            break;
        }
      }, function (error) {
        // Handle unsuccessful uploads
        console.log(error);
      }, function () {
        // Handle successful uploads on complete
        console.log(uploadTask.snapshot);
        var img = {};
        img['BOL'] = uploadTask.snapshot.downloadURL;
        img['File'] = file.name;
        this.downloadURL = img;
        __WEBPACK_IMPORTED_MODULE_2__fireBaseInit__["a" /* default */].collection('freight').doc(id).update(img);
        vm.$emit('finished');
      });
    }
  },
  watch: {
    downloadURL: function downloadURL() {
      this.updateFirestore();
    },
    fileList: function fileList() {
      this.uploadFile(this.fileList);
    }
  }
});

/***/ }),
/* 204 */,
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailHelp_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b18fec2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailHelp_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b18fec2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailHelp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b18fec2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailHelp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: 'list_alt', iconClass: 'teal', title: 'Shipping Instructions', subtitle: 'Additional shiping items for broker.' }, { icon: 'done', iconClass: 'teal', title: 'Finalize Shipment', subtitle: 'Remove shipment form inbox.' }, { icon: 'account_circle', iconClass: 'teal', title: 'Add Broker', subtitle: 'Add an additional Broker to shipment.' }, { icon: 'photo_camera', iconClass: 'teal', title: 'Upload File', subtitle: 'Upload bill of lading.' }, { icon: 'attach_file', iconClass: 'teal', title: 'Download File', subtitle: 'Download bill of lading.' }, { icon: 'assignment', iconClass: 'teal', title: 'Shipment details', subtitle: 'View shipment details.' }, { icon: 'remove_circle_outline', iconClass: 'teal', title: 'Decline Shipment', subtitle: 'Remove yourself from the shipment.' }]
    };
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WayBill__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chat__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_print_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_print_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DetailHelp__ = __webpack_require__(205);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: { waybill: __WEBPACK_IMPORTED_MODULE_1__WayBill__["a" /* default */], brokerName: __WEBPACK_IMPORTED_MODULE_5__BrokerName__["a" /* default */], chat: __WEBPACK_IMPORTED_MODULE_2__Chat__["a" /* default */], help: __WEBPACK_IMPORTED_MODULE_7__components_DetailHelp__["a" /* default */] },
  props: ['shipmentID', 'brokerID'],
  name: 'brokerfreightdetail',
  data: function data() {
    return {
      shipment: {},
      googleUrl: null,
      dialog: false,
      shippingQuote: null,
      messages: [],
      snackbar: false,
      toggle: false,
      warnDialog: false,
      quote: {},
      freightID: '',
      showImage: false,
      showHelp: false,
      imageURL: '',
      shippingLabel: 'Shipping Quote'
    };
  },

  watch: {},
  computed: {},
  mounted: function mounted() {
    var _this = this;

    this.$bind('shipment', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.shipmentID)).then(function (doc) {
      if (doc.brokers[__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid] === true) {
        _this.freightID = _this.shipmentID;
        _this.getMap();
        _this.clearMessageFlag();
        _this.imageURL = _this.shipment.BOL;
        _this.shippingLabel = _this.shipment.Equipment + ' Quote';
      } else {
        alert('Cannot Access this Shipment');
        _this.shipment = 'Invalid';
        _this.freightID = 'Invalid';
      }
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  methods: {
    print: function print() {
      __WEBPACK_IMPORTED_MODULE_6_print_js___default()({ printable: 'my-node', type: 'html', documentTitle: 'Kangaruu - Shipping Instructions' });
    },
    getMap: function getMap() {
      this.toggle = true;
      if (typeof this.shipment !== 'undefined' && this.shipment) {
        var start = this.shipment.Pickup[0];
        var end = this.shipment.Delivery[this.shipment.Delivery.length - 1];
        var points = '';
        for (var i = 1; i < this.shipment.Pickup.length; i++) {
          var str = this.shipment.Pickup[i];
          points = points + str.replace(/ /g, '+') + '| ';
        }
        for (var _i = 0; _i < this.shipment.Delivery.length; _i++) {
          var _str = this.shipment.Delivery[_i];
          points = points + _str.replace(/ /g, '+') + '| ';
        }
        points = points.substring(0, points.length - 2);

        this.googleUrl = 'https://www.google.com/maps/embed/v1/directions?key=AIzaSyCw3FKI8Eh1SY6rfwJkba1LL3Aetx9RrvI&origin=' + start + '&destination=' + end + '&waypoints=' + points;
      }
    },
    downLoadFile: function downLoadFile() {
      var fileName = this.shipment.File;
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' });
        console.log(xhr.response);
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        // Create a DOMString representing the blob
        // and point the link element towards it
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        // programatically click the link to trigger the download
        a.click();
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      };
      xhr.open('GET', this.shipment.BOL);
      xhr.send();
    },

    saveQuote: function saveQuote() {
      var quote = Number(this.shippingQuote);
      if (quote > 0) {
        var num = '$' + quote.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
        var msg = {};
        msg['quote'] = num;
        msg['status'] = 'Quoted';
        this.onSend('New Rate - ' + num);
        __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid).update(msg);
        this.shippingQuote = '';
        this.snackbar = true;
        // create rate record
        var rate = {};
        if (this.shipment.City) {
          rate['city'] = this.shipment.City;
        }
        if (this.shipment.Miles) {
          rate['miles'] = this.shipment.Miles;
        }
        rate['quote'] = quote;
        rate['type'] = this.shipment.Equipment;
        rate['shipment'] = this.shipmentID;
        rate['date'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
        __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('rates').add(rate);

        // Update quoteCount
        var senderRef = __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid);
        return senderRef.get().then(function (snap) {
          var quoteCount = snap.data().quoteCount + 1;
          if (isNaN(quoteCount)) {
            quoteCount = 1;
          }
          var data = { quoteCount: quoteCount };
          return senderRef.update(data);
        });
      } else {
        alert('Quote must be a real dollar amount.');
      }
    },
    onSend: function onSend(message) {
      var _this2 = this;

      var msg = {};
      msg['message'] = message;
      msg['sender'] = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid;
      msg['created'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid).collection('messages').add(msg);

      // update freight to new message
      var userList = this.shipment.newMessages;
      var messages = {};
      userList[this.shipment.Shipper] = true;
      messages['newMessages'] = userList;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(messages);
      // update Broker to new message
      var newMsg = {};
      newMsg['newMessage'] = true;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid).update(newMsg);

      // send push to shipper
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(this.shipment.Shipper).get().then(function (snap) {
        if (snap.data().sendPush) {
          __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('push').add({ sendTo: '' + _this2.shipment.Shipper });
        }
      });
    },

    logout: function logout() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signOut().then(function () {
        _this3.$router.replace('/');
      });
    },
    clearMessageFlag: function clearMessageFlag() {
      var userList = {};
      userList = this.shipment.newMessages;
      var messages = {};
      userList[__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid] = false;
      messages['newMessages'] = userList;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(messages);
    },
    removeShipment: function removeShipment() {
      var userList = {};
      userList = this.shipment.brokers;
      var brokers = {};
      userList[__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid] = false;
      brokers['brokers'] = userList;
      console.log(brokers);
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(brokers);
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid).update({ isActive: false });
      this.$router.replace({ path: '/viewfreight' });
    }
  },
  firestore: function firestore() {
    return {
      shipment: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.shipmentID),
      messages: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.shipmentID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid).collection('messages').orderBy('created'),
      quote: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.shipmentID).collection('brokers').doc(__WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid)
    };
  }
});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ccd34a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(332)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08ccd34a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ccd34a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08ccd34a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MessageList__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MessageInput__ = __webpack_require__(338);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Chat',
  updated: function updated() {
    document.querySelectorAll('.messages')[0].scrollTop = 10000000; // eslint-disable-line
  },

  props: ['onSend', 'messages'],
  components: {
    MessageList: __WEBPACK_IMPORTED_MODULE_0__MessageList__["a" /* default */],
    MessageInput: __WEBPACK_IMPORTED_MODULE_1__MessageInput__["a" /* default */]
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(335);
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MessageList',
  props: ['messages'],
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__Message__["a" /* default */]
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['message'],
  computed: {
    time: function time() {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(this.message.created).format('MM/DD/YYYY hh:mm');
    },
    isSender: function isSender() {
      var userID = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.uid;
      if (userID === this.message.sender) {
        return true;
      } else {
        return false;
      }
    }
  },
  name: 'Message'
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MessageInput',
  props: ['onSend'],
  methods: {
    onKeyDown: function onKeyDown() {
      if (this.message) {
        var cleanString = this.message.replace(/[|~`"<>()/\\{}^]/g, '');
        this.onSend(cleanString.substring(0, 50));
        this.message = '';
      }
    }
  },
  data: function data() {
    return {
      message: '',
      messageRules: [function (v) {
        return v.length <= 50 || 'Each line should be less than 50 characters';
      }]
    };
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Chat__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'brokerdetail',
  props: ['brokerID', 'freightID'],
  components: { chat: __WEBPACK_IMPORTED_MODULE_2__Chat__["a" /* default */], brokerName: __WEBPACK_IMPORTED_MODULE_1__BrokerName__["a" /* default */] },
  data: function data() {
    return {
      title: null,
      messages: {},
      quotes: {},
      shipment: {}
    };
  },

  calculated: {},
  mounted: function mounted() {
    var _this = this;

    this.$bind('quotes', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID)).then(function (doc) {
      _this.clearMessageFlag();
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  methods: {
    calculateRate: function calculateRate(quote, miles) {
      var nQuote = 0;
      var nMiles = 0;
      if (quote != null) {
        nQuote = parseFloat(quote.replace(/[$,]+/g, ''));
      }
      if (miles != null) {
        nMiles = parseFloat(miles.replace(/[$,]+/g, ''));
      }
      console.log(quote, nQuote, nMiles);
      var currentRate = 2.75;
      var avgRate = currentRate * nMiles;
      var rateDiff = avgRate - nQuote;
      // console.log(rateDiff)
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      var rateDiffString = formatter.format(rateDiff);
      console.log(avgRate, rateDiff, nQuote);
      if (avgRate >= nQuote && nQuote > 0 && nMiles > 0) {
        return rateDiffString + ' below market rate.';
      } else if (avgRate < nQuote && nQuote > 0 && nMiles > 0) {
        return rateDiffString + ' above market rate.';
      }
    },
    logout: function logout() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().signOut().then(function () {
        _this2.$router.replace('/');
      });
    },
    clearMessageFlag: function clearMessageFlag() {
      var messages = {};
      messages['newMessage'] = false;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).update(messages);
    },
    onSend: function onSend(message) {
      var _this3 = this;

      var msg = {};
      msg['message'] = message;
      msg['sender'] = __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().currentUser.uid;
      msg['created'] = __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix();
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).collection('messages').add(msg);

      // update freight to new message
      var userList = this.shipment.newMessages;
      var messages = {};
      userList[this.brokerID] = true;
      messages['newMessages'] = userList;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID).update(messages);

      // send push
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(this.brokerID).get().then(function (snap) {
        if (snap.data().sendPush) {
          __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('push').add({ sendTo: '' + _this3.brokerID });
        }
      });
    }
  },
  firestore: function firestore() {
    return {
      messages: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('conversations').doc(this.freightID).collection('brokers').doc(this.brokerID).collection('messages').orderBy('created'),
      shipment: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('freight').doc(this.freightID)
    };
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { brokerName: __WEBPACK_IMPORTED_MODULE_1__BrokerName__["a" /* default */] },

  name: 'brokers',
  data: function data() {
    return {
      user: {},
      selected: [],
      selectedBroker: [],
      newBrokers: [],
      inviteBrokers: false,
      showBrokers: false,
      brokers: [],
      search: '',
      snackbar: false,
      email: '',
      firstName: '',
      lastName: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      headers: [{
        text: 'Brokers',
        align: 'left',
        sortable: true,
        value: false
      }, { text: 'Company', value: false }]
    };
  },
  firestore: function firestore() {
    return {
      brokers: __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').where('isBroker', '==', true)
    };
  },

  mounted: function mounted() {
    this.$bind('user', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid)).then(function (doc) {
      // all good
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  computed: {},
  watch: {
    user: function user() {
      console.log('here I am');
      return null;
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut().then(function () {
        _this.$router.replace('/');
      });
    },
    toggle: function toggle(index) {
      var i = this.selected.indexOf(index);

      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
    },
    guid: function guid() {
      function _p8(s) {
        var p = (Math.random().toString(16) + '00000000').substr(2, 6);
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
      }
      return _p8();
    },

    sendEmail: function sendEmail() {
      var _this2 = this;

      this.inviteBrokers = false;
      // var user = Firebase.auth().currentUser
      var mail = {};
      mail['firstName'] = this.firstName;
      mail['lastName'] = this.lastName;
      mail['email'] = this.email;
      mail['senderEmail'] = this.user.email;
      mail['senderName'] = this.user.username;
      mail['senderLastName'] = this.user.lastname;
      mail['senderCompany'] = this.user.company;
      mail['senderRef'] = this.guid();
      mail['senderID'] = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('mail').add(mail).then(function (snap) {
        _this2.snackbar = true;
      });
    },
    addBrokers: function addBrokers() {
      this.showBrokers = false;
      if (this.selectedBroker.length > 0) {
        var brokerList = {};
        for (var i = 0; i < this.selectedBroker.length; i++) {
          brokerList['' + this.selectedBroker[i].id] = true;
        }
        for (var key in this.user.brokers) {
          brokerList[key] = true;
        }
        var brokerObj = { brokers: brokerList };
        __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid).update(brokerObj);
      }
    },
    updateBrokers: function updateBrokers() {
      this.newBrokers = this.brokers.slice();
      for (var i = 0; i < this.newBrokers.length; i++) {
        for (var key in this.user.brokers) {
          console.log(key);
          if (this.newBrokers[i].id === key) {
            this.newBrokers.splice(i, 1);
          }
        }
      }
      this.showBrokers = true;
    },
    deleteBroker: function deleteBroker(deleteKey) {
      var brokerList = {};
      for (var key in this.user.brokers) {
        console.log(key, deleteKey);
        if (key !== deleteKey) {
          brokerList[key] = true;
        }
      }
      var brokerObj = { brokers: brokerList };
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid).update(brokerObj);
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrokerName__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { brokerName: __WEBPACK_IMPORTED_MODULE_1__BrokerName__["a" /* default */] },

  name: 'brokers',
  props: ['brokerID'],
  data: function data() {
    return {
      selected: [],
      selectedBroker: [],
      newBrokers: [],
      inviteBrokers: false,
      showBrokers: false,
      shippers: [],
      search: '',
      user: [],
      snackbar: false,
      email: '',
      firstName: '',
      lastName: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      headers: [{
        text: 'Brokers',
        align: 'left',
        sortable: true,
        value: false
      }, { text: 'Company', value: false }]
    };
  },
  firestore: function firestore() {},

  computed: {},
  mounted: function mounted() {
    var bs = 'brokers.' + this.brokerID;
    this.$bind('shippers', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').where(bs, '==', true)).then(function (doc) {
      // all good
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });

    this.$bind('user', __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid)).then(function (doc) {
      // all good
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },
  watch: {
    user: function user() {
      console.log('here I am');
      return null;
    }
  },
  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().signOut().then(function () {
        _this.$router.replace('/');
      });
    },
    toggle: function toggle(index) {
      var i = this.selected.indexOf(index);

      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        this.selected.push(index);
      }
    },

    deleteShipper: function deleteShipper(deleteKey) {
      var brokerList = {};
      var brokerID = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.uid;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(deleteKey).get().then(function (snap) {
        for (var key in snap.data().brokers) {
          if (key !== brokerID) {
            brokerList[key] = true;
          }
          var brokerObj = { brokers: brokerList };
          __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('users').doc(deleteKey).update(brokerObj);
        }
      });
    },
    sendEmail: function sendEmail() {
      var _this2 = this;

      this.inviteBrokers = false;
      // var user = Firebase.auth().currentUser
      var mail = {};
      mail['firstName'] = this.firstName;
      mail['lastName'] = this.lastName;
      mail['email'] = this.email;
      mail['senderEmail'] = this.user.email;
      mail['senderName'] = this.user.username;
      mail['senderLastName'] = this.user.lastname;
      mail['senderCompany'] = this.user.company;
      __WEBPACK_IMPORTED_MODULE_0__fireBaseInit__["a" /* default */].collection('mail').add(mail).then(function (snap) {
        _this2.snackbar = true;
      });
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      email: '',
      password: '',
      notVerified: false,
      forgotPassword: false,
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }]
    };
  },
  methods: {
    sendEmail: function sendEmail() {
      this.forgotPassword = false;
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().sendPasswordResetEmail(this.email).then(function () {
        alert('Email Sent');
      }).catch(function (error) {
        alert('Oops. ' + error.message);
      });
    },
    signIn: function signIn() {
      var _this = this;

      // logout
      this.$emit('logout', true);

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        if (user.emailVerified) {
          _this.$router.replace('viewfreight');
        } else {
          _this.notVerified = true;
          user.sendEmailVerification();
        }
      }, function (err) {
        alert('Oops. ' + err.message);
      });
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signUp',
  data: function data() {
    return {
      email: '',
      password: '',
      passwordConfirm: '',
      error: '',
      alert: false,
      userType: 'shipper',
      company: '',
      username: '',
      lastname: '',
      userID: '',
      ref: '',
      mobile: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        );
      }],
      nameRules: [function (v) {
        return !!v || 'UserName is required';
      }],
      companyRules: [function (v) {
        return !!v || 'Company Name is required';
      }],
      phoneRules: [function (v) {
        return (/^$|^(\+\d{1,4})?[\s-]?\(?(\d{3})\)?[\s-]?\d{3}[\s-]?\d{4}/.test(v) || 'Mobile number must be valid'
        );
      }]
    };
  },

  methods: {
    signUp: function signUp() {
      var _this = this;

      if (this.comparePasswords !== true) {
        return;
      }
      var broker = true;
      var shipper = true;
      if (this.userType === 'shipper') {
        broker = false;
      } else {
        shipper = false;
      }
      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().createUserWithEmailAndPassword(this.email, this.password).then(function (user) {
        alert('Your account has been created, a conformation email has been sent to your email address.');
        user.sendEmailVerification();
        user.updateProfile({
          displayName: _this.username
        });
        _this.userID = user.uid;
        __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(user.uid).set({
          email: _this.email,
          company: _this.company,
          username: _this.username,
          lastname: _this.lastname,
          type: _this.userType,
          active: true,
          isBroker: broker,
          isShipper: shipper,
          mobile: _this.mobile,
          sendSMS: true,
          referral: _this.ref
        });
        // update shipper
        if (broker && _this.ref) {
          _this.getShipper(_this.ref, _this.userID);
        }
        _this.$router.replace('/');
      }, function (err) {
        alert('Oops. ' + err.message);
      });
    },
    getShipper: function getShipper(senderRef, brokerID) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('mail').where('senderRef', '==', senderRef).get().then(function (snap) {
        snap.forEach(function (doc) {
          _this2.updateShipper(doc.data().senderID, brokerID);
        });
      });
    },
    updateShipper: function updateShipper(shipperID, brokerID) {
      console.log(shipperID);
      __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(shipperID).get().then(function (snap) {
        var brokerList = {};
        brokerList[brokerID] = true;
        for (var key in snap.data().brokers) {
          brokerList[key] = true;
        }
        var brokerObj = { brokers: brokerList };
        console.log(brokerObj);
        __WEBPACK_IMPORTED_MODULE_1__fireBaseInit__["a" /* default */].collection('users').doc(shipperID).update(brokerObj);
      });
    }
  },
  computed: {
    comparePasswords: function comparePasswords() {
      return this.password === this.passwordConfirm ? true : 'Passwords don\'t match';
    }
  },
  watch: {
    user: function user(value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/');
      }
    },
    error: function error(value) {
      if (value) {
        this.alert = true;
      }
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_goodshare_src_providers_Facebook_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_goodshare_src_providers_Twitter_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_goodshare_src_providers_LinkedIn_vue__ = __webpack_require__(223);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      name: 'info',
      domain: 'kangaruu.com'
    };
  },

  components: {
    VueFacebook: __WEBPACK_IMPORTED_MODULE_0_vue_goodshare_src_providers_Facebook_vue__["a" /* default */], VueTwitter: __WEBPACK_IMPORTED_MODULE_1_vue_goodshare_src_providers_Twitter_vue__["a" /* default */], VueLinkedIn: __WEBPACK_IMPORTED_MODULE_2_vue_goodshare_src_providers_LinkedIn_vue__["a" /* default */]
  },
  computed: {
    address: function address() {
      return 'mailto:' + this.name + '@' + this.domain;
    },
    addressText: function addressText() {
      return this.name + '@' + this.domain;
    }
  },
  props: ['brokerID'],
  firestore: function firestore() {
    return {};
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Facebook_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2eb20686_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Facebook_vue__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(354)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2eb20686"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Facebook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2eb20686_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Facebook_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2eb20686_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Facebook_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueGoodshareFacebook',
  props: {
    page_url: {
      type: String,
      default: document.location.href
    },
    button_design: {
      type: String,
      default: 'flat'
    },
    title_social: String,
    has_icon: Boolean,
    has_square_edges: Boolean,
    has_counter: Boolean
  },
  data: function data() {
    return {
      buttonSocialDesignObject: {
        'button-social__square_edges': this.$props.has_square_edges,
        'facebook__design__flat': this.$props.button_design === 'flat',
        'facebook__design__gradient': this.$props.button_design === 'gradient',
        'facebook__design__outline': this.$props.button_design === 'outline'
      },
      counter_facebook: 0
    };
  },

  methods: {
    /**
     * Get a random integer between `min` and `max`.
     *
     * @param {number} min - min number
     * @param {number} max - max number
     * @return {number} a random integer
     */
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    /**
     * Slice thousand integer and add `k` letter.
     *
     * @param {number} number - thousand integer
     * @return {string} a integer with letter
     */
    sliceThousandInt: function sliceThousandInt(number) {
      return (number / 1000).toFixed(1) + 'k';
    },

    /**
     * Show share window.
     *
     * @return {object} a pop-up window
     */
    showShareWindow: function showShareWindow() {
      // Variables
      var width = 640;
      var height = 640;
      var left = screen.width / 2 - width / 2;
      var top = screen.height / 2 - height / 2;
      var window_config = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',';
      var share_url = 'https://www.facebook.com/sharer/sharer.php?' + 'u=' + encodeURIComponent(this.$props.page_url);

      return window.open(share_url, 'Share this', window_config + 'toolbar=no,menubar=no,scrollbars=no');
    },

    /**
     * Get share counter.
     *
     * @return {object} a share counter
     */
    getShareCounter: function getShareCounter() {
      var _this = this;

      // Variables
      var script = document.createElement('script');
      var callback = 'vue_goodshare_' + this.getRandomInt(1, 2345);

      // Create `script` tag with share count URL
      script.src = 'https://graph.facebook.com?' + 'id=' + encodeURIComponent(this.$props.page_url) + '&callback=' + callback;

      // Add `script` tag with share count URL
      // to end of `body` tag
      document.body.appendChild(script);

      // Set share count to `counter_facebook` v-model
      window[callback] = function (count) {
        if (count.share) {
          _this.counter_facebook = count.share.share_count >= 1000 ? _this.sliceThousandInt(count.share.share_count) : count.share.share_count;
        }
      };
    }
  },
  mounted: function mounted() {
    // Show share counter when page loaded
    if (this.$props.has_counter) this.getShareCounter();
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Twitter_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c6f0418_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Twitter_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(357)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c6f0418"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Twitter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c6f0418_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Twitter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7c6f0418_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Twitter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueGoodshareTwitter',
  props: {
    page_url: {
      type: String,
      default: document.location.href
    },
    page_title: {
      type: String,
      default: document.title
    },
    button_design: {
      type: String,
      default: 'flat'
    },
    title_social: String,
    has_icon: Boolean,
    has_square_edges: Boolean
  },
  data: function data() {
    return {
      buttonSocialDesignObject: {
        'button-social__square_edges': this.$props.has_square_edges,
        'twitter__design__flat': this.$props.button_design === 'flat',
        'twitter__design__gradient': this.$props.button_design === 'gradient',
        'twitter__design__outline': this.$props.button_design === 'outline'
      }
    };
  },

  methods: {
    /**
     * Show share window.
     *
     * @return {object} a pop-up window
     */
    showShareWindow: function showShareWindow() {
      // Variables
      var width = 640;
      var height = 640;
      var left = screen.width / 2 - width / 2;
      var top = screen.height / 2 - height / 2;
      var window_config = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',';
      var share_url = 'https://twitter.com/share?' + 'url=' + encodeURIComponent(this.$props.page_url) + '&text=' + encodeURIComponent(this.$props.page_title);

      return window.open(share_url, 'Share this', window_config + 'toolbar=no,menubar=no,scrollbars=no');
    }
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LinkedIn_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63c01c48_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LinkedIn_vue__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(359)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63c01c48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LinkedIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63c01c48_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LinkedIn_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63c01c48_hasScoped_true_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LinkedIn_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Variables
var description = document.querySelector('meta[name="description"]');

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VueGoodshareLinkedIn',
  props: {
    page_url: {
      type: String,
      default: document.location.href
    },
    page_title: {
      type: String,
      default: document.title
    },
    page_description: {
      type: String,
      default: description ? description.content : ''
    },
    button_design: {
      type: String,
      default: 'flat'
    },
    title_social: String,
    has_icon: Boolean,
    has_square_edges: Boolean,
    has_counter: Boolean
  },
  data: function data() {
    return {
      buttonSocialDesignObject: {
        'button-social__square_edges': this.$props.has_square_edges,
        'linkedin__design__flat': this.$props.button_design === 'flat',
        'linkedin__design__gradient': this.$props.button_design === 'gradient',
        'linkedin__design__outline': this.$props.button_design === 'outline'
      },
      counter_linkedin: 0
    };
  },

  methods: {
    /**
     * Get a random integer between `min` and `max`.
     *
     * @param {number} min - min number
     * @param {number} max - max number
     * @return {number} a random integer
     */
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    /**
     * Slice thousand integer and add `k` letter.
     *
     * @param {number} number - thousand integer
     * @return {string} a integer with letter
     */
    sliceThousandInt: function sliceThousandInt(number) {
      return (number / 1000).toFixed(1) + 'k';
    },

    /**
     * Show share window.
     *
     * @return {object} a pop-up window
     */
    showShareWindow: function showShareWindow() {
      // Variables
      var width = 640;
      var height = 640;
      var left = screen.width / 2 - width / 2;
      var top = screen.height / 2 - height / 2;
      var window_config = 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',';
      var share_url = 'https://www.linkedin.com/shareArticle?' + 'url=' + encodeURIComponent(this.$props.page_url) + '&text=' + encodeURIComponent(this.$props.page_title) + '&summary=' + encodeURIComponent(this.$props.page_description) + '&mini=true';

      return window.open(share_url, 'Share this', window_config + 'toolbar=no,menubar=no,scrollbars=no');
    },

    /**
     * Get share counter.
     *
     * @return {object} a share counter
     */
    getShareCounter: function getShareCounter() {
      var _this = this;

      // Variables
      var script = document.createElement('script');
      var callback = 'vue_goodshare_' + this.getRandomInt(1, 2345);

      // Create `script` tag with share count URL
      script.src = 'https://www.linkedin.com/countserv/count/share?' + 'url=' + encodeURIComponent(this.$props.page_url) + '&callback=' + callback;

      // Add `script` tag with share count URL
      // to end of `body` tag
      document.body.appendChild(script);

      // Set share count to `counter_linkedin` v-model
      window[callback] = function (count) {
        if (count) {
          _this.counter_linkedin = count.count >= 1000 ? _this.sliceThousandInt(count.count) : count.count;
        }
      };
    }
  },
  mounted: function mounted() {
    // Show share counter when page loaded
    if (this.$props.has_counter) this.getShareCounter();
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['imageURL', 'freightID', 'isBroker', 'imageName'],
  components: {},
  methods: {
    downLoadFile: function downLoadFile() {
      var fileName = this.imageName;
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function (event) {
        var blob = new Blob([xhr.response], { type: 'image/png' });
        console.log(xhr.response);
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);
        // Create a DOMString representing the blob
        // and point the link element towards it
        var url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        // programatically click the link to trigger the download
        a.click();
        // release the reference to the file by revoking the Object URL
        window.URL.revokeObjectURL(url);
      };
      xhr.open('GET', this.imageURL);
      xhr.send();
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_goodshare_src_providers_Facebook_vue__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_goodshare_src_providers_Twitter_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_goodshare_src_providers_LinkedIn_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tweet_embed__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_tweet_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_tweet_embed__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    VueFacebook: __WEBPACK_IMPORTED_MODULE_0_vue_goodshare_src_providers_Facebook_vue__["a" /* default */], VueTwitter: __WEBPACK_IMPORTED_MODULE_1_vue_goodshare_src_providers_Twitter_vue__["a" /* default */], VueLinkedIn: __WEBPACK_IMPORTED_MODULE_2_vue_goodshare_src_providers_LinkedIn_vue__["a" /* default */], Timeline: __WEBPACK_IMPORTED_MODULE_3_vue_tweet_embed__["Timeline"]
  },
  data: function data() {
    return {
      items: [{ isTweet: true,
        tweetID: '1015667296147144704',
        title: 'Blockchain in Freight' }, { isTweet: true,
        tweetID: '1015635114070458368',
        title: 'Who is using Blockchain' }, { isTweet: true,
        tweetID: '1014913722752516096',
        title: 'Blockchain' }, { isTweet: true,
        tweetID: '1014908534650097664',
        title: 'Getting the best shipping rate' }, { isTweet: true,
        tweetID: '1014224974322659328',
        title: 'Kangaruu Software Tip' }, { isTweet: true,
        tweetID: '1014224187743920128',
        title: 'Organized Chat' }, { isTweet: true,
        tweetID: '1014189884859269120',
        title: 'New Kangaruu Feature' }, { isTweet: false,
        title: 'Average Van Rates Hit New High in Spot Market',
        date: 'June 28, 2018',
        linkText: 'Kangaruu',
        linkAddress: 'https://kangaruu.com',
        text: 'Dry Van CPI - $2.31 \n\n                Trucks are in limited supply in key markets causing rates to soar over $.20 per mile in June.\n                \n                Our Weekly rates are derived from Spot market averages for the month.\n                ' }, { isTweet: false,
        title: 'Press Release',
        date: 'June 19, 2018',
        linkText: 'Official Press Release',
        linkAddress: 'https://www.prnewswire.com/news-releases/digital-freight-startup-announces-the-public-launch-of-its-freight-platform-kangaruucom-300667682.html',

        text: 'Digital Freight Startup Announces the Public Launch of Its Freight Platform Kangaruu.com Kangaruu creates a persistent organized communication tool to manage logistics between shippers and brokers in the $45 billion spot market\n                \n                TEMECULA, Calif., June 19, 2018 (Newswire.com) - Kangaruu is pleased to announce the public launch of its freight management platform.Kangaruu.com was created by technology and trucking industry experts in 2018 to digitize the trucking industry.\n                \n                Kangaruu uses the latest cloud - based technologies and artificial intelligence algorithms to create a simple, yet powerful, freight management process for both shippers and brokers.\n                \n                Kangaruu understands that the transportation industry is built on relationships.These relationships in the spot market produce 180 million truckloads each year.Current technology is fragmented and based on email, phone calls and faxes.Kangaruu moves past these old technologies and provides a modern cross - platform solution, centered around the freight quote in real time.\n                \n                \u201CWe worked with industry experts to create a digital solution that saves time and eliminates confusion.We provide collaboration tools to get the best rate quote for the shipper while preserving their broker relationship, \u201D said Kip Haas, Kangaruu\u2019s CEO.\n                \n                New \u201Cdigital brokers\u201D have failed to understand the importance of the shipper-to - broker relationship.In their efforts to eliminate the broker with automation and artificial discounts, they have struggled to build lasting relationships with shippers.This is partly due to their lack of infrastructure to reap the benefits of digitization.But, it is mainly due to their core belief that the traditional broker relationship isn\u2019t valuable in today\u2019s marketplace.\n                \n                \u201CWe want to empower and facilitate the shipping transaction for all parties, including the shipper, broker and the carrier.Our job is to help them work together in a simple, transparent and seamless manner, \u201D said Mr.Haas.\n                \n                One of Kangaruu\u2019s early adopters summed it up best: \u201CKangaruu has cleaned up my inbox, simplified my workflow and increased my productivity.\u201D \u2013 Brooke, shipper.\n                \n                \n                Email Contact: Info@kangaruu.com' }]
    };
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuefire__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app = null;

__WEBPACK_IMPORTED_MODULE_6_firebase___default.a.auth().onAuthStateChanged(function (user) {
  /* eslint-disable no-new */
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
      },
      template: '<App/>',
      render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
      },
      mounted: function mounted() {},
      data: function data() {
        return {};
      }
    });
  }
});

/***/ }),
/* 229 */,
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfdffe8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfdffe8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5dfdffe8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-toolbar',{attrs:{"dense":"","app":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/news"}},[_vm._v("\n        News\n      ")]),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/login"}},[_vm._v("\n        login\n      ")])],1),_vm._v(" "),_c('main',[_c('v-content',[_c('router-view')],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"teal--text darken-2",attrs:{"fixed":_vm.fixed,"app":""}},[_c('span',{staticClass:"copyright"},[_vm._v("© 2018 Kangaruu")]),_vm._v(" "),_c('v-spacer')],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ViewFreight__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NewFreight__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FreightDetail__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BrokerFreightDetail__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_BrokerDetail__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Brokers__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shippers__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SignUp__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Hello__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ViewImages__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Error404_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_News_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_firebase__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'hello',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Hello__["a" /* default */]
  }, {
    path: '/viewfreight',
    name: 'viewfreight',
    component: __WEBPACK_IMPORTED_MODULE_2__components_ViewFreight__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/freight',
    name: 'newfreight',
    component: __WEBPACK_IMPORTED_MODULE_3__components_NewFreight__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/brokerfreight',
    name: 'brokerfreight',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_5__components_BrokerFreightDetail__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/broker',
    name: 'brokerdetail',
    component: __WEBPACK_IMPORTED_MODULE_6__components_BrokerDetail__["a" /* default */],
    props: true,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/shipperfreight',
    name: 'shipperfreight',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_4__components_FreightDetail__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/viewimages',
    name: 'viewimages',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_12__components_ViewImages__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/brokers',
    name: 'brokers',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Brokers__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/shippers',
    name: 'shippers',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Shippers__["a" /* default */],
    props: true,
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Login__["a" /* default */]
  }, {
    path: '/news',
    name: 'news',
    component: __WEBPACK_IMPORTED_MODULE_14__components_News_vue__["a" /* default */]
  }, {
    path: '/signup',
    name: 'signup',
    component: __WEBPACK_IMPORTED_MODULE_10__components_SignUp__["a" /* default */]
  }, {
    path: '/404',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Error404_vue__["default"]
  }, {
    path: '/index.html',
    name: 'index',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Hello__["a" /* default */]
  }, {
    path: '*',
    redirect: '/404'
  }]
});

router.beforeEach(function (to, from, next) {
  var currentUser = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.auth().currentUser;
  var requiresAuth = to.matched.some(function (record) {
    return record.meta.requiresAuth;
  });

  if (requiresAuth && !currentUser) {
    next('/');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

var messaging = __WEBPACK_IMPORTED_MODULE_15_firebase___default.a.messaging();
messaging.onTokenRefresh(function () {
  messaging.getToken().then(function (refreshedToken) {
    console.log('Token refreshed.');
    // Indicate that the new Instance ID token has not yet been sent to the
    // app server.
    // setTokenSentToServer(false)
    // Send Instance ID token to app server.
    // sendTokenToServer(refreshedToken)
    // ...
  }).catch(function (err) {
    console.log('Unable to retrieve refreshed token ', err);
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewFreight_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff7640_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewFreight_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewFreight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff7640_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewFreight_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dff7640_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewFreight_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: 'AIzaSyAmyePdUHeJ93MgcwcYYKPcAwanYN6oYG8',
  authDomain: 'vuedemo-2c254.firebaseapp.com',
  databaseURL: 'https://vuedemo-2c254.firebaseio.com',
  projectId: 'vuedemo-2c254',
  storageBucket: 'vuedemo-2c254.appspot.com',
  messagingSenderId: '515184925658'
});

/***/ }),
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolBar_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c29fc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToolBar_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToolBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c29fc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToolBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c29fc6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToolBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-navigation-drawer',{attrs:{"app":"","right":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-divider'),_vm._v(" "),_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"href":item.href,"to":{name: item.href}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""},domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}})],1)],1)]})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu - Beta")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":""},on:{"click":_vm.logout}},[_vm._v("\n      logout\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.drawer = !_vm.drawer}}},[_c('v-icon',{staticClass:"teal--text darken-2"},[_vm._v("more_vert")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerToolBar_vue__ = __webpack_require__(48);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94602cfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerToolBar_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerToolBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94602cfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerToolBar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94602cfa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerToolBar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-navigation-drawer',{attrs:{"app":"","right":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-divider'),_vm._v(" "),_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:index,attrs:{"href":item.href,"to":{name: item.href}}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"light":""},domProps:{"innerHTML":_vm._s(item.icon)}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.title)}})],1)],1)]})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu - Beta")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":""},on:{"click":_vm.logout}},[_vm._v("\n            logout\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.drawer = !_vm.drawer}}},[_c('v-icon',{staticClass:"teal--text darken-2"},[_vm._v("more_vert")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.broker.company)+": "+_vm._s(_vm.broker.username)+" "+_vm._s(_vm.broker.lastname)+"\n")])}
var staticRenderFns = []


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreightSearch_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_411c5f6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightSearch_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreightSearch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_411c5f6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightSearch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_411c5f6e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightSearch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"v-bind":_vm.getShipment}},[_vm._l((_vm.shipments),function(shipment){return _c('v-list',{key:shipment.id,attrs:{"two-line":""}},[_c('v-list-tile',{attrs:{"ripple":""},on:{"click":function($event){_vm.toggle(shipment.id)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"blue--text darken-4"},[_vm._l((shipment.newMessages),function(msg,key,index){return _c('span',{key:index},[(_vm.id === key && msg === true)?_c('v-icon',{staticClass:"red--text darken-4"},[_vm._v("fiber_new")]):_vm._e()],1)}),_vm._v(" "),_vm._l((shipment.isSelected),function(selected,key){return _c('span',{key:key},[(_vm.id === key && selected === true)?_c('v-icon',{staticClass:"blue--text darken-4"},[_vm._v("check_circle")]):_vm._e()],1)}),_vm._v("\n          "+_vm._s(shipment.Delivery[shipment.Delivery.length - 1])+"\n        ")],2),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"orange--text darken-4"},[_vm._v("\n          "+_vm._s(shipment.PickupDate)+"\n        ")]),_vm._v(" "),_c('v-list-tile-action-text',{staticClass:"teal--text darken-4"},[_c('broker-name',{attrs:{"brokerID":shipment.Shipper}}),_vm._v("\n          - "+_vm._s(shipment.Reference)+"\n        ")],1)],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),(!Object.keys(_vm.shipments).length)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',{staticClass:"blue--text darken-4"},[_vm._v("\n          No Completed Shipments available.\n        ")])],1)],1)],1):_vm._e()],2)}
var staticRenderFns = []


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InboxHelp_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2edbedd1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InboxHelp_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InboxHelp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2edbedd1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InboxHelp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2edbedd1_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InboxHelp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("FAQ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"flat":"","outline":""}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Home")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Return to Inbox")])],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"ripple":""}},[_c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),(_vm.isShipper)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal","to":"/brokers"}},[_c('v-icon',[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),(_vm.isBroker)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showShippers()}}},[_c('v-icon',[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),(_vm.isShipper)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal","to":"/freight"}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.settings = true}}},[_c('v-icon',[_vm._v("settings")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showFreightSearch = true}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showHelp = true}}},[_c('v-icon',[_vm._v("help")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showHelp),callback:function ($$v) {_vm.showHelp=$$v},expression:"showHelp"}},[_c('v-card',[_c('help'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"","outline":""},nativeOn:{"click":function($event){_vm.showHelp = false}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.showFreightSearch),callback:function ($$v) {_vm.showFreightSearch=$$v},expression:"showFreightSearch"}},[_c('v-card',[_c('freight-search',{attrs:{"id":_vm.brokerID,"isBroker":_vm.isBroker},on:{"cargo":_vm.toggle}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.showFreightSearch = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.settings),callback:function ($$v) {_vm.settings=$$v},expression:"settings"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("User Settings")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.phoneRules,"hint":"Get Text alerts when there is a new shipment","persistent-hint":""},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}},[_vm._v("\n                "+_vm._s(_vm.mobile)+"\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-switch',{attrs:{"label":"Send Text Notifications"},model:{value:(_vm.txt),callback:function ($$v) {_vm.txt=$$v},expression:"txt"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Send Conformation Email"},model:{value:(_vm.receipt),callback:function ($$v) {_vm.receipt=$$v},expression:"receipt"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Send Push Notifications"},nativeOn:{"click":function($event){_vm.enablePush()}},model:{value:(_vm.push),callback:function ($$v) {_vm.push=$$v},expression:"push"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.settings = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.updatePhone()}}},[_vm._v("Update")])],1)],1)],1),_vm._v(" "),(!Object.keys(_vm.shipments).length && _vm.isShipper)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',{staticClass:"blue--text darken-4"},[_vm._v("\n          No Open Shipments, Invite your Brokers\n          "),_c('v-icon',[_vm._v("account_circle")]),_vm._v("and create a shipment\n          "),_c('v-icon',[_vm._v("add")]),_vm._v(" from the toolbar.\n        ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),(!Object.keys(_vm.shipments).length && _vm.isBroker)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',{staticClass:"blue--text darken-4"},[_vm._v("\n          No Open Shipments. Invite your Shippers\n          "),_c('v-icon',[_vm._v("account_circle")]),_vm._v(" to use Kangaruu from the toolbar.\n        ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.shipments),function(shipment){return _c('v-list',{key:shipment.id,attrs:{"two-line":""}},[_c('v-list-tile',{attrs:{"ripple":""},on:{"click":function($event){_vm.toggle(shipment.id)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"blue--text darken-4"},[_vm._l((shipment.newMessages),function(msg,key,index){return _c('span',{key:index},[(_vm.userID === key && msg === true)?_c('v-icon',{staticClass:"red--text darken-4"},[_vm._v("fiber_new")]):_vm._e()],1)}),_vm._v(" "),_vm._l((shipment.isSelected),function(selected,key){return _c('span',{key:key},[(_vm.userID === key && selected === true)?_c('v-icon',{staticClass:"blue--text darken-4"},[_vm._v("check_circle")]):_vm._e()],1)}),_vm._v("\n          "+_vm._s(shipment.Delivery[shipment.Delivery.length - 1])+"\n        ")],2),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"orange--text darken-4"},[_vm._v("\n          "+_vm._s(shipment.PickupDate)+" -\n          "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(shipment.Equipment))])]),_vm._v(" "),_c('v-list-tile-action-text',{staticClass:"teal--text darken-4"},[_c('broker-name',{attrs:{"brokerID":shipment.Shipper}}),_vm._v("\n          - "+_vm._s(shipment.Reference)+"\n        ")],1)],1)],1),_vm._v(" "),_c('v-divider')],1)})],2)}
var staticRenderFns = []


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFreight_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723640e9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFreight_vue__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFreight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723640e9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFreight_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723640e9_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewFreight_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pickup_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3d93870_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pickup_vue__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pickup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3d93870_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pickup_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3d93870_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pickup_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_autocomplete_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7268d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_autocomplete_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7268d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_autocomplete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7268d3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_autocomplete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"autocomplete",attrs:{"type":"text","label":_vm.label,"id":_vm.id,"placeholder":_vm.placeholder,"prepend-icon":"location_on"},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp},model:{value:(_vm.autocompleteText),callback:function ($$v) {_vm.autocompleteText=$$v},expression:"autocompleteText"}})}
var staticRenderFns = []


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-flex',{attrs:{"xs10":""}},[_c('vue-google-autocomplete',{ref:"address",attrs:{"id":_vm.pickupType,"placeholder":" ","autofocus":"","label":_vm.pickupType},on:{"placechanged":_vm.getAddressData}}),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","nudge-right":40,"min-width":"290px","return-value":_vm.date},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.pickupType,"prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu.save(_vm.date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"blue"},nativeOn:{"click":function($event){return _vm.clearField($event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"teal"},nativeOn:{"click":function($event){return _vm.nextStep($event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check")])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c431522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c431522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c431522_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleMap_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{staticClass:"google-map",attrs:{"color":"orange","fab":"","dark":"","small":""},nativeOn:{"click":function($event){_vm.calculateDistances()}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("access_time")])],1),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.distance)+" ")])],1)}
var staticRenderFns = []


/***/ }),
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 65,
	"./af.js": 65,
	"./ar": 66,
	"./ar-dz": 67,
	"./ar-dz.js": 67,
	"./ar-kw": 68,
	"./ar-kw.js": 68,
	"./ar-ly": 69,
	"./ar-ly.js": 69,
	"./ar-ma": 70,
	"./ar-ma.js": 70,
	"./ar-sa": 71,
	"./ar-sa.js": 71,
	"./ar-tn": 72,
	"./ar-tn.js": 72,
	"./ar.js": 66,
	"./az": 73,
	"./az.js": 73,
	"./be": 74,
	"./be.js": 74,
	"./bg": 75,
	"./bg.js": 75,
	"./bm": 76,
	"./bm.js": 76,
	"./bn": 77,
	"./bn.js": 77,
	"./bo": 78,
	"./bo.js": 78,
	"./br": 79,
	"./br.js": 79,
	"./bs": 80,
	"./bs.js": 80,
	"./ca": 81,
	"./ca.js": 81,
	"./cs": 82,
	"./cs.js": 82,
	"./cv": 83,
	"./cv.js": 83,
	"./cy": 84,
	"./cy.js": 84,
	"./da": 85,
	"./da.js": 85,
	"./de": 86,
	"./de-at": 87,
	"./de-at.js": 87,
	"./de-ch": 88,
	"./de-ch.js": 88,
	"./de.js": 86,
	"./dv": 89,
	"./dv.js": 89,
	"./el": 90,
	"./el.js": 90,
	"./en-SG": 91,
	"./en-SG.js": 91,
	"./en-au": 92,
	"./en-au.js": 92,
	"./en-ca": 93,
	"./en-ca.js": 93,
	"./en-gb": 94,
	"./en-gb.js": 94,
	"./en-ie": 95,
	"./en-ie.js": 95,
	"./en-il": 96,
	"./en-il.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./eo": 98,
	"./eo.js": 98,
	"./es": 99,
	"./es-do": 100,
	"./es-do.js": 100,
	"./es-us": 101,
	"./es-us.js": 101,
	"./es.js": 99,
	"./et": 102,
	"./et.js": 102,
	"./eu": 103,
	"./eu.js": 103,
	"./fa": 104,
	"./fa.js": 104,
	"./fi": 105,
	"./fi.js": 105,
	"./fo": 106,
	"./fo.js": 106,
	"./fr": 107,
	"./fr-ca": 108,
	"./fr-ca.js": 108,
	"./fr-ch": 109,
	"./fr-ch.js": 109,
	"./fr.js": 107,
	"./fy": 110,
	"./fy.js": 110,
	"./ga": 111,
	"./ga.js": 111,
	"./gd": 112,
	"./gd.js": 112,
	"./gl": 113,
	"./gl.js": 113,
	"./gom-latn": 114,
	"./gom-latn.js": 114,
	"./gu": 115,
	"./gu.js": 115,
	"./he": 116,
	"./he.js": 116,
	"./hi": 117,
	"./hi.js": 117,
	"./hr": 118,
	"./hr.js": 118,
	"./hu": 119,
	"./hu.js": 119,
	"./hy-am": 120,
	"./hy-am.js": 120,
	"./id": 121,
	"./id.js": 121,
	"./is": 122,
	"./is.js": 122,
	"./it": 123,
	"./it-ch": 124,
	"./it-ch.js": 124,
	"./it.js": 123,
	"./ja": 125,
	"./ja.js": 125,
	"./jv": 126,
	"./jv.js": 126,
	"./ka": 127,
	"./ka.js": 127,
	"./kk": 128,
	"./kk.js": 128,
	"./km": 129,
	"./km.js": 129,
	"./kn": 130,
	"./kn.js": 130,
	"./ko": 131,
	"./ko.js": 131,
	"./ku": 132,
	"./ku.js": 132,
	"./ky": 133,
	"./ky.js": 133,
	"./lb": 134,
	"./lb.js": 134,
	"./lo": 135,
	"./lo.js": 135,
	"./lt": 136,
	"./lt.js": 136,
	"./lv": 137,
	"./lv.js": 137,
	"./me": 138,
	"./me.js": 138,
	"./mi": 139,
	"./mi.js": 139,
	"./mk": 140,
	"./mk.js": 140,
	"./ml": 141,
	"./ml.js": 141,
	"./mn": 142,
	"./mn.js": 142,
	"./mr": 143,
	"./mr.js": 143,
	"./ms": 144,
	"./ms-my": 145,
	"./ms-my.js": 145,
	"./ms.js": 144,
	"./mt": 146,
	"./mt.js": 146,
	"./my": 147,
	"./my.js": 147,
	"./nb": 148,
	"./nb.js": 148,
	"./ne": 149,
	"./ne.js": 149,
	"./nl": 150,
	"./nl-be": 151,
	"./nl-be.js": 151,
	"./nl.js": 150,
	"./nn": 152,
	"./nn.js": 152,
	"./pa-in": 153,
	"./pa-in.js": 153,
	"./pl": 154,
	"./pl.js": 154,
	"./pt": 155,
	"./pt-br": 156,
	"./pt-br.js": 156,
	"./pt.js": 155,
	"./ro": 157,
	"./ro.js": 157,
	"./ru": 158,
	"./ru.js": 158,
	"./sd": 159,
	"./sd.js": 159,
	"./se": 160,
	"./se.js": 160,
	"./si": 161,
	"./si.js": 161,
	"./sk": 162,
	"./sk.js": 162,
	"./sl": 163,
	"./sl.js": 163,
	"./sq": 164,
	"./sq.js": 164,
	"./sr": 165,
	"./sr-cyrl": 166,
	"./sr-cyrl.js": 166,
	"./sr.js": 165,
	"./ss": 167,
	"./ss.js": 167,
	"./sv": 168,
	"./sv.js": 168,
	"./sw": 169,
	"./sw.js": 169,
	"./ta": 170,
	"./ta.js": 170,
	"./te": 171,
	"./te.js": 171,
	"./tet": 172,
	"./tet.js": 172,
	"./tg": 173,
	"./tg.js": 173,
	"./th": 174,
	"./th.js": 174,
	"./tl-ph": 175,
	"./tl-ph.js": 175,
	"./tlh": 176,
	"./tlh.js": 176,
	"./tr": 177,
	"./tr.js": 177,
	"./tzl": 178,
	"./tzl.js": 178,
	"./tzm": 179,
	"./tzm-latn": 180,
	"./tzm-latn.js": 180,
	"./tzm.js": 179,
	"./ug-cn": 181,
	"./ug-cn.js": 181,
	"./uk": 182,
	"./uk.js": 182,
	"./ur": 183,
	"./ur.js": 183,
	"./uz": 184,
	"./uz-latn": 185,
	"./uz-latn.js": 185,
	"./uz.js": 184,
	"./vi": 186,
	"./vi.js": 186,
	"./x-pseudo": 187,
	"./x-pseudo.js": 187,
	"./yo": 188,
	"./yo.js": 188,
	"./zh-cn": 189,
	"./zh-cn.js": 189,
	"./zh-hk": 190,
	"./zh-hk.js": 190,
	"./zh-tw": 191,
	"./zh-tw.js": 191
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8c47a34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8c47a34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8c47a34_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("FAQ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"flat":"","outline":""}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Home")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Return to Inbox")])],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"c",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showHelp = true}}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('v-stepper',{model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.e1 > 1,"editable":""}},[_vm._v("Equipment")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.e1 > 2,"editable":""}},[_vm._v("Pickup")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3","complete":_vm.e1 > 3,"editable":""}},[_vm._v("Destination")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4","complete":_vm.e1 > 4,"editable":""}},[_vm._v("Freight")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"5","complete":_vm.e1 > 5,"editable":""}},[_vm._v("Notes")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.truck),callback:function ($$v) {_vm.truck=$$v},expression:"truck"}},[_c('v-radio',{attrs:{"label":"OTR","value":"OTR"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"LTL","value":"LTL"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"RAIL","value":"RAIL"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"FLAT BED","value":"FLAT BED"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"teal"},nativeOn:{"click":function($event){return _vm.addEquipment($event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('pickup',{attrs:{"deliveryDate":_vm.pickupDate,"pickupType":"Pickup"},on:{"cargo":_vm.newCargo,"city":_vm.getCity,"nextStep":function($event){_vm.e1++}}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('pickup',{attrs:{"deliveryDate":_vm.deliveryDate,"pickupType":"Delivery"},on:{"cargo":_vm.newCargo,"city":_vm.getCity,"nextStep":function($event){_vm.e1++}}}),_vm._v(" "),_c('google-map',{attrs:{"pickupDate":_vm.pickupDate,"deliveryDate":_vm.deliveryDate,"pickupAddresses":_vm.pickupAddresses,"deliveryAddresses":_vm.deliveryAddresses},on:{"newDate":_vm.addDate}})],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-text-field',{ref:"freight",attrs:{"label":"Freight","id":"freight"},model:{value:(_vm.freight),callback:function ($$v) {_vm.freight=$$v},expression:"freight"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"blue"},nativeOn:{"click":function($event){_vm.addFreight(false)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.addFreight(true)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-text-field',{ref:"options",attrs:{"label":"Notes","id":"options"},model:{value:(_vm.options),callback:function ($$v) {_vm.options=$$v},expression:"options"}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"blue"},nativeOn:{"click":function($event){_vm.addOptions(false)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.showBrokers=true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("check")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.chips),function(chip,index){return [_c('v-chip',{key:index,style:({ color: _vm.chipColor(chip) }),attrs:{"close":"","outline":"","label":""},on:{"input":function($event){_vm.remove(chip)}}},[_vm._v(_vm._s(chip)+"\n        ")])]})],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.showBrokers),callback:function ($$v) {_vm.showBrokers=$$v},expression:"showBrokers"}},[_c('v-card',[_c('v-card-title',[_vm._v("Broker List")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.user.brokers),function(broker,key){return _c('v-list',{key:key},[_c('v-list-tile',[_c('v-list-tile-title',[_c('broker-name',{attrs:{"brokerID":key}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"value":key},model:{value:(_vm.brokers),callback:function ($$v) {_vm.brokers=$$v},expression:"brokers"}})],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addOptions(true)}}},[_vm._v("Send")])],1)],2)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showHelp),callback:function ($$v) {_vm.showHelp=$$v},expression:"showHelp"}},[_c('v-card',[_c('help'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"","outline":""},nativeOn:{"click":function($event){_vm.showHelp = false}}},[_vm._v("OK")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreightDetail_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14d52a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightDetail_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(289)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FreightDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14d52a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b14d52a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FreightDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"orange lighten-4"},[_c('v-card-text',[_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Shipment: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.shipment.Reference))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Equipment: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.shipment.Equipment))]),_c('br'),_vm._v(" "),_vm._l((_vm.shipment.Pickup),function(pickup){return _c('div',{key:pickup.id},[_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Pickup: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(pickup))]),_c('br')])}),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Pickup Date: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.shipment.PickupDate))]),_c('br'),_vm._v(" "),_vm._l((_vm.shipment.Delivery),function(delivery){return _c('div',{key:delivery.id},[_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Delivery: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(delivery))]),_c('br')])}),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Delivery Date: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.shipment.DeliveryDate))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Miles: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.shipment.Miles))]),_c('br'),_vm._v(" "),_vm._l((_vm.shipment.Freight),function(freight){return _c('div',{key:freight.id},[_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Freight: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(freight))]),_c('br')])}),_vm._v(" "),_vm._l((_vm.shipment.Options),function(option){return _c('div',{key:option.id},[_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Notes: ")])]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(option))]),_c('br')])}),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Quote: ")]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.quotes.quote))]),_c('br')]),_vm._v(" "),(_vm.quotes.selected)?_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Tender: ")]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v("Yes")]),_c('br')]):_vm._e(),_vm._v(" "),(!_vm.quotes.selected)?_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Tender: ")]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_vm._v("No")]),_c('br')]):_vm._e(),_vm._v(" "),(!_vm.isBroker && _vm.brokerID)?_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Broker: ")]),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('broker-name',{attrs:{"brokerID":_vm.brokerID}})],1),_c('br')]):_vm._e(),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('span',{staticClass:"black--text"},[_c('b',[_vm._v("Shipping Instructions: ")]),_c('br')]),_vm._v(" "),(_vm.quotes.selected || !_vm.isBroker)?_c('pre',[_vm._v("        "),_c('div',{staticClass:"black--text",staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.shipment.Instructions)+"\n             ")])]):_vm._e(),_c('br')],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.isBroker)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.$emit('closeWaybill')}}},[_c('v-icon',[_vm._v("close")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.$emit('printWaybill')}}},[_c('v-icon',[_vm._v("print")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBrokers_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef07a2be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBrokers_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBrokers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef07a2be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBrokers_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ef07a2be_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBrokers_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Add Brokers")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.newBrokers,"headers":_vm.headers,"item-key":"id","no-data-text":"No new brokers available","select-all":""},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n          "+_vm._s(props.header.text)+"\n        ")]),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(props.header.text)+"\n        ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company))])]}}]),model:{value:(_vm.selectedBroker),callback:function ($$v) {_vm.selectedBroker=$$v},expression:"selectedBroker"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addBrokers()}}},[_vm._v("Ok")])],1)],1)}
var staticRenderFns = []


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploader_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdb61d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(325)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fdb61d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdb61d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fdb61d8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileUploader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []


/***/ }),
/* 327 */,
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("FAQ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-tile',{key:item.title,attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"flat":"","outline":""}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Home")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Return to Inbox")])],1)],1)],2)}
var staticRenderFns = []


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showHelp = true}}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-toolbar',{staticClass:"teal"},[_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"white"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewfreight' })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-card',[_c('div',{staticClass:"google-maps"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.googleUrl,"width":"400","height":"300","frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',{staticStyle:{"display":"none"}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                Bill of Lading:\n                "),(_vm.shipment.BOL)?_c('v-icon',{on:{"click":function($event){$event.stopPropagation();_vm.showImage = true}}},[_vm._v("pageview")]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile-action-text',[_c('input',{ref:"imageUpload",attrs:{"accept":"image/*, .pdf","type":"file"},on:{"change":function($event){_vm.detectFiles($event.target.files)}}}),_vm._v(" "),_c('file-uploader',{attrs:{"fileList":_vm.fileList,"freightID":_vm.freightID},on:{"bytes":_vm.changeBytes,"finished":_vm.uploadDone}})],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.brokers),function(broker,key,index){return [_c('v-list-tile',{key:broker.id},[_c('v-list-tile-content',{attrs:{"ripple":""},on:{"click":function($event){_vm.showBroker(broker.id)}}},[_c('v-list-tile-title',[(broker.newMessage)?_c('v-icon',{staticClass:"red--text darken-4"},[_vm._v("fiber_new")]):_vm._e(),_vm._v(" "),_c('broker-name',{staticClass:"teal--text daarken-4",attrs:{"brokerID":broker.id}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"orange--text daarken-4"},[_vm._v("\n                  "+_vm._s(broker.quote)+"\n                ")]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"blue--text caption"},[_vm._v("\n                  "+_vm._s(_vm.calculateRate(broker.quote, _vm.shipment.Miles))+"\n                ")])],1),_vm._v(" "),(broker.selected)?_c('v-list-tile-action-text',[_vm._v("Tendered")]):_vm._e(),_vm._v(" "),(!broker.selected)?_c('v-list-tile-action-text',[_vm._v("Tender")]):_vm._e(),_vm._v(" "),_c('v-list-tile-action',{on:{"click":function($event){_vm.selectBrokers(broker.id, broker.selected)}}},[_c('v-switch',{attrs:{"color":"green"},model:{value:(broker.selected),callback:function ($$v) {_vm.$set(broker, "selected", $$v)},expression:"broker.selected"}})],1)],1),_vm._v(" "),_c('v-divider',{key:index})]})],2),_vm._v(" "),_c('v-slide-y-transition',[_c('v-card-text',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWaybill),expression:"showWaybill"}]},[_c('waybill',{attrs:{"freightID":_vm.shipmentID,"isBroker":false,"brokerID":_vm.brokerID,"id":"my-node"},on:{"closeWaybill":function($event){_vm.showWaybill = false},"printWaybill":function($event){_vm.print()}}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"200"},model:{value:(_vm.showImage),callback:function ($$v) {_vm.showImage=$$v},expression:"showImage"}},[_c('v-card',{on:{"closeImage":function($event){_vm.showImage=false}}},[_c('v-card-title',[_vm._v("Available Images")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('div',{staticStyle:{"overflow":"scroll","-webkit-overflow-scrolling":"touch","width":"300px"}},[_c('iframe',{staticStyle:{"width":"600px"},attrs:{"src":_vm.imageURL}},[_vm._v("Oops! an error has occurred.")])])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showImage=false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.brokerDialog),callback:function ($$v) {_vm.brokerDialog=$$v},expression:"brokerDialog"}},[_c('add-brokers',{attrs:{"freightID":_vm.shipmentID},on:{"closeBroker":function($event){_vm.brokerDialog=false}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.editor),callback:function ($$v) {_vm.editor=$$v},expression:"editor"}},[_c('v-card',{attrs:{"color":"grey lighten-4","flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"name":"shipping","label":"Shipping Instructions","autofocus":"","textarea":""},model:{value:(_vm.instructions),callback:function ($$v) {_vm.instructions=$$v},expression:"instructions"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.sendInstructions(true)}}},[_vm._v("\n                Send\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.sendInstructions(false)}}},[_vm._v("\n                Save\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.editor = false}}},[_vm._v("\n                Cancel\n              ")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[(_vm.uploading)?_c('v-progress-circular',{attrs:{"value":_vm.bytes,"color":"red"}}):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":"","color":"teal"},nativeOn:{"click":function($event){_vm.editor=true}},slot:"activator"},[_c('v-icon',[_vm._v("list_alt")])],1),_vm._v(" "),_c('span',[_vm._v("Create Shipping Instructions")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":"","color":"teal"},nativeOn:{"click":function($event){_vm.warnDialog=true}},slot:"activator"},[_c('v-icon',[_vm._v("done")])],1),_vm._v(" "),_c('span',[_vm._v("Finalize Shipment")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":"","color":"teal"},nativeOn:{"click":function($event){_vm.brokerDialog=true}},slot:"activator"},[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('span',[_vm._v("Add A Broker")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(!_vm.shipment.BOL)?_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},on:{"click":function($event){_vm.onPickFile()}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("photo_camera")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Upload Bill Of Lading")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.shipment.BOL)?_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewimages', params: { freightID: _vm.freightID, imageURL: _vm.imageURL, isBroker: false, imageName: _vm.shipment.File } })}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("attach_file")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("View Bill Of Lading")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.showWaybill = true}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("assignment")])],1),_vm._v(" "),_c('span',[_vm._v("View Shipment Details")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.warnDialog),callback:function ($$v) {_vm.warnDialog=$$v},expression:"warnDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Finalize this Shipment?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Finalizing a shipment will remove it from your and your BROKERS active shipments. Shipments should be finalized after delivery.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.warnDialog = false}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.removeShipment()}}},[_vm._v("Agree")])],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":4000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      File Uploaded!\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showHelp),callback:function ($$v) {_vm.showHelp=$$v},expression:"showHelp"}},[_c('v-card',[_c('help'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"","outline":""},nativeOn:{"click":function($event){_vm.showHelp = false}}},[_vm._v("OK")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerFreightDetail_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43119536_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerFreightDetail_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(331)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerFreightDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43119536_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerFreightDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43119536_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerFreightDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6265bc27_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(334)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6265bc27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6265bc27_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6265bc27_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5f088e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5f088e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5f088e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.isSender)?_c('div',{staticClass:"text-xs-right"},[_c('small',[_vm._v(_vm._s(_vm.time))])]):_vm._e(),_vm._v(" "),(_vm.isSender)?_c('p',{staticClass:"text-xs-right"},[_c('v-chip',{attrs:{"color":"orange","text-color":"white"}},[_vm._v(_vm._s(_vm.message.message))])],1):_vm._e(),_vm._v(" "),(!_vm.isSender)?_c('div',[_c('small',[_vm._v(_vm._s(_vm.time))])]):_vm._e(),_vm._v(" "),(!_vm.isSender)?_c('p',[(!_vm.isSender)?_c('v-chip',{attrs:{"color":"teal","text-color":"white"}},[_vm._v(_vm._s(_vm.message.message))]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('ul',{staticClass:"messages"},_vm._l((_vm.messages),function(item){return _c('Message',{key:item.id,attrs:{"message":item}})}))])}
var staticRenderFns = []


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInput_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9770084_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInput_vue__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MessageInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9770084_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9770084_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MessageInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',{attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.onKeyDown($event)}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onKeyDown($event)}}},[_c('v-layout',[_c('v-text-field',{attrs:{"placeholder":"Message","id":"message","prepend-icon":"textsms","rules":_vm.messageRules,"counter":50,"type":"text"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"indigo","type":"submit"}},[_vm._v("Send")])],1)}
var staticRenderFns = []


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"blue--text darken-4"},[_vm._v("Messages")]),_vm._v(" "),_c('MessageList',{attrs:{"messages":_vm.messages}}),_vm._v(" "),_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('MessageInput',{attrs:{"onSend":_vm.onSend}})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","router":"","color":"teal"},nativeOn:{"click":function($event){_vm.showHelp = true}}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-toolbar',{staticClass:"teal"},[_c('v-toolbar-title',{staticClass:"white--text"},[(_vm.toggle)?_c('broker-name',{attrs:{"brokerID":_vm.shipment.Shipper}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"white"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewfreight' })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-card',[_c('div',{staticClass:"google-maps"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.googleUrl,"width":"400","height":"300","frameborder":"0"}})]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveQuote($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.shippingLabel,"required":"","prepend-icon":"attach_money"},model:{value:(_vm.shippingQuote),callback:function ($$v) {_vm.shippingQuote=$$v},expression:"shippingQuote"}})],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":4000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n                    Rate Has Been Updated!\n                    "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"green","type":"submit"}},[_vm._v("Save")])],1)])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('chat',{attrs:{"messages":_vm.messages,"onSend":_vm.onSend}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('waybill',{attrs:{"freightID":_vm.shipmentID,"isBroker":true,"brokerID":_vm.brokerID,"id":"my-node"},on:{"printWaybill":function($event){_vm.print()}}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.warnDialog=true}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("remove_circle_outline")])],1),_vm._v(" "),_c('span',[_vm._v("Decline Shipment")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.quote.selected && !_vm.imageURL === '')?_c('v-btn',{attrs:{"slot":"activator","icon":"","small":"","flat":""},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewimages', params: { freightID: _vm.freightID, imageURL: _vm.imageURL, isBroker: true, imageName: _vm.shipment.File } })}},slot:"activator"},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("attach_file")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("DownLoad Bill Of Lading")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.warnDialog),callback:function ($$v) {_vm.warnDialog=$$v},expression:"warnDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Decline this Shipment?")]),_vm._v(" "),_c('v-card-text',[_vm._v("Declining a shipment will remove it from your active shipments.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.warnDialog = false}}},[_vm._v("Disagree")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":""},nativeOn:{"click":function($event){_vm.removeShipment()}}},[_vm._v("Agree")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"200"},model:{value:(_vm.showImage),callback:function ($$v) {_vm.showImage=$$v},expression:"showImage"}},[_c('v-card',{on:{"closeImage":function($event){_vm.showImage=false}}},[_c('v-card-title',[_vm._v("Available Images")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('a',{attrs:{"href":_vm.imageURL}},[_vm._v("\n            "+_vm._s(_vm.shipment.File)+"\n          ")])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showImage=false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showHelp),callback:function ($$v) {_vm.showHelp=$$v},expression:"showHelp"}},[_c('v-card',[_c('help'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","flat":"","outline":""},nativeOn:{"click":function($event){_vm.showHelp = false}}},[_vm._v("OK")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerDetail_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014c9fce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerDetail_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BrokerDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014c9fce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerDetail_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014c9fce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BrokerDetail_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-toolbar',{staticClass:"teal"},[_c('v-toolbar-title',{staticClass:"white--text"},[_c('broker-name',{attrs:{"brokerID":_vm.brokerID}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"white"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'shipperfreight', params: { shipmentID: _vm.freightID } })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"teal--text daarken-4"},[_vm._v("Shipping Quote: "+_vm._s(_vm.quotes.quote))]),_vm._v(" "),(_vm.shipment.Miles)?_c('v-list-tile-sub-title',{staticClass:"blue--text caption"},[_vm._v("\n              "+_vm._s(_vm.calculateRate(_vm.quotes.quote, _vm.shipment.Miles))+"\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.quotes.selected)?_c('v-icon',{staticClass:"blue--text darken-4"},[_vm._v("check_circle")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('chat',{attrs:{"messages":_vm.messages,"onSend":_vm.onSend}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brokers_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf562c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brokers_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Brokers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf562c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brokers_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf562c00_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Brokers_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"teal","dark":""}},[_c('v-toolbar-title',[_vm._v("My Brokers")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.inviteBrokers = true}}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.updateBrokers($event)}}},[_c('v-icon',[_vm._v("search")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"white"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewfreight' })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.showBrokers),callback:function ($$v) {_vm.showBrokers=$$v},expression:"showBrokers"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Add Brokers")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.newBrokers,"headers":_vm.headers,"no-data-text":"No new brokers available","item-key":"id","select-all":""},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('v-tooltip',{attrs:{"bottom":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_vm._v("\n                    "+_vm._s(props.header.text)+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(props.header.text)+"\n                  ")])])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company))])]}}]),model:{value:(_vm.selectedBroker),callback:function ($$v) {_vm.selectedBroker=$$v},expression:"selectedBroker"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addBrokers()}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.inviteBrokers),callback:function ($$v) {_vm.inviteBrokers=$$v},expression:"inviteBrokers"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Invite Brokers")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"First Name","required":""},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Last Name","required":""},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.inviteBrokers = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.sendEmail()}}},[_vm._v("Send")])],1)],1)],1),_vm._v(" "),(!Object.keys(_vm.user).length)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',{staticClass:"blue--text darken-4"},[_vm._v("\n                This is where you manage your brokers. Invite your Brokers to Kangaruu\n                "),_c('v-icon',[_vm._v("email")]),_vm._v(" or add them from the global list\n                "),_c('v-icon',[_vm._v("search")]),_vm._v(" using the toolbar.\n              ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.user.brokers),function(broker,key,index){return [_c('v-list-tile',{key:index,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('broker-name',{attrs:{"brokerID":key}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"}),_vm._v(" "),_c('v-list-tile-sub-title')],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_c('v-btn',{attrs:{"icon":"","ripple":""},nativeOn:{"click":function($event){_vm.deleteBroker(key)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("delete")])],1)],1)],1)],1)]}),_vm._v(" "),_c('v-divider')],2)],1)],1),_vm._v(" "),(_vm.snackbar == true)?_c('v-snackbar',{attrs:{"timeout":4000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      Email has been sent!\n      "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shippers_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8df5e4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shippers_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shippers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8df5e4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shippers_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8df5e4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shippers_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"small":"","router":"","flat":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',[_vm._v("exit_to_app")])],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"teal","dark":""}},[_c('v-toolbar-title',[_vm._v("My Shippers")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.inviteBrokers = true}}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"white"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewfreight' })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.inviteBrokers),callback:function ($$v) {_vm.inviteBrokers=$$v},expression:"inviteBrokers"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Invite Shippers")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"First Name","required":""},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Last Name","required":""},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.inviteBrokers = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.sendEmail()}}},[_vm._v("Send")])],1)],1)],1),_vm._v(" "),(!Object.keys(_vm.shippers).length)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',{staticClass:"blue--text darken-4"},[_vm._v("\n                                This is where you see your active shippers. Invite other Shippers to join Kangaruu\n                                "),_c('v-icon',[_vm._v("email")]),_vm._v(" to increase your business.\n                            ")],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_vm._l((_vm.shippers),function(broker,key,index){return [_c('v-list-tile',{key:broker.id,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.toggle(index)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('broker-name',{attrs:{"brokerID":broker.id}})],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text--primary"})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-list-tile-action-text',[_c('v-btn',{attrs:{"icon":"","ripple":""},nativeOn:{"click":function($event){_vm.deleteShipper(broker.id)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("delete")])],1)],1)],1)],1),_vm._v(" "),(index + 1 < _vm.shippers.length)?_c('v-divider',{key:index}):_vm._e()]}),_vm._v(" "),_c('v-divider')],2)],1)],1),_vm._v(" "),(_vm.snackbar == true)?_c('v-snackbar',{attrs:{"timeout":4000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n            Email has been sent!\n            "),_c('v-btn',{attrs:{"dark":"","flat":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c96c29_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c96c29_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16c96c29_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signIn($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"email","label":"Mail","id":"email","type":"email","autofocus":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit"}},[_vm._v("Sign in")]),_vm._v(" "),(_vm.notVerified === true)?_c('span',{staticClass:"red--text"},[_vm._v("Another verification email has been set to your email address. Please check you Spam filter.")]):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"flat":"","small":"","color":"teal"},nativeOn:{"click":function($event){_vm.forgotPassword = true}}},[_vm._v("\n                                        Forgot Password\n                                    ")])],1)],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.forgotPassword),callback:function ($$v) {_vm.forgotPassword=$$v},expression:"forgotPassword"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Forgot Password")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"rules":_vm.emailRules,"label":"Email","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*indicates required field")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.forgotPassword = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.sendEmail()}}},[_vm._v("Send")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b41e95_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b41e95_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b41e95_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('v-container',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.signUp($event)}}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-alert',{attrs:{"type":"error","dismissible":""},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_vm._v("\n                    "+_vm._s(_vm.error)+"\n                  ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"email","label":"eMail","id":"email","type":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","id":"password","type":"password","required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","rules":[_vm.comparePasswords]},model:{value:(_vm.passwordConfirm),callback:function ($$v) {_vm.passwordConfirm=$$v},expression:"passwordConfirm"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"company","label":"Company","id":"company","type":"company","required":"","rules":_vm.companyRules},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"username","label":"First name","id":"username","type":"username","required":"","rules":_vm.nameRules},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"lastname","label":"Last name","id":"lastname","type":"lastname","required":"","rules":_vm.nameRules},model:{value:(_vm.lastname),callback:function ($$v) {_vm.lastname=$$v},expression:"lastname"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"mobile","label":"Mobile (Optional: For Text Notifications)","id":"Mobile","rules":_vm.phoneRules,"type":"mobile"},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"name":"ref","label":"Referral Code","id":"ref","type":"ref","counter":6},model:{value:(_vm.ref),callback:function ($$v) {_vm.ref=$$v},expression:"ref"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.userType),callback:function ($$v) {_vm.userType=$$v},expression:"userType"}},[_c('v-radio',{attrs:{"label":"Shipper","value":"shipper"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Broker","value":"broker"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"type":"submit"}},[_vm._v("Sign up")])],1)],1)],1)])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e6e70f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(353)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e6e70f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e6e70f_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */,
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-social",class:_vm.buttonSocialDesignObject,attrs:{"page-url":_vm.page_url,"button-design":_vm.button_design,"title-social":_vm.title_social,"has-icon":_vm.has_icon,"has-square-edges":_vm.has_square_edges,"has-counter":_vm.has_counter},on:{"click":function($event){$event.preventDefault();return _vm.showShareWindow($event)}}},[(this.$props.has_icon)?_c('i',{staticClass:"icon-facebook"}):_vm._e(),_vm._v(" "),(this.$props.title_social)?_c('span',{staticClass:"title-social"},[_vm._v(_vm._s(_vm.title_social))]):_vm._e(),_vm._v(" "),(this.$props.has_counter)?_c('span',{staticClass:"counter-facebook",model:{value:(_vm.counter_facebook),callback:function ($$v) {_vm.counter_facebook=$$v},expression:"counter_facebook"}},[_vm._v(_vm._s(_vm.counter_facebook))]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-social",class:_vm.buttonSocialDesignObject,attrs:{"page-url":_vm.page_url,"page-title":_vm.page_title,"button-design":_vm.button_design,"title-social":_vm.title_social,"has-icon":_vm.has_icon,"has-square-edges":_vm.has_square_edges},on:{"click":function($event){$event.preventDefault();return _vm.showShareWindow($event)}}},[(this.$props.has_icon)?_c('i',{staticClass:"icon-twitter"}):_vm._e(),_vm._v(" "),(this.$props.title_social)?_c('span',{staticClass:"title-social"},[_vm._v(_vm._s(_vm.title_social))]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-social",class:_vm.buttonSocialDesignObject,attrs:{"page-url":_vm.page_url,"page-title":_vm.page_title,"page-description":_vm.page_description,"button-design":_vm.button_design,"title-social":_vm.title_social,"has-icon":_vm.has_icon,"has-square-edges":_vm.has_square_edges,"has-counter":_vm.has_counter},on:{"click":function($event){$event.preventDefault();return _vm.showShareWindow($event)}}},[(this.$props.has_icon)?_c('i',{staticClass:"icon-linkedin"}):_vm._e(),_vm._v(" "),(this.$props.title_social)?_c('span',{staticClass:"title-social"},[_vm._v(_vm._s(_vm.title_social))]):_vm._e(),_vm._v(" "),(this.$props.has_counter)?_c('span',{staticClass:"counter-linkedin",model:{value:(_vm.counter_linkedin),callback:function ($$v) {_vm.counter_linkedin=$$v},expression:"counter_linkedin"}},[_vm._v(_vm._s(_vm.counter_linkedin))]):_vm._e()])}
var staticRenderFns = []


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('section',[_c('v-parallax',{attrs:{"src":"static/track.jpg","height":"350"}},[_c('v-layout',{staticClass:"black--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":"static/logoGreen.png","height":"100","alt":"train track"}}),_vm._v(" "),_c('h1',{staticClass:"black--text mb-2 display-1 text-xs-center"},[_vm._v("KANGARUU")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("Where The Spot Market Hops")]),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 mt-5",attrs:{"dark":"","large":"","href":"/signup"}},[_vm._v("\n                    Get Started for Free\n                ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("The best way to ship")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("\n                        Working with the Brokers and Relationships you already have\n                    ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('vue-facebook',{attrs:{"button_design":"outline","has_icon":""}}),_vm._v(" "),_c('vue-Twitter',{attrs:{"button_design":"outline","has_icon":""}}),_vm._v(" "),_c('vue-linked-in',{attrs:{"button_design":"outline","has_icon":""}})],1)])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"height":"250"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"large":""}},[_vm._v("local_shipping")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Manage Shipments")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                                    Kangaruu organizes conversations, shipping rates, and brokers for each shipment. No more chasing email, text messages, faxes and phone calls. No more sorting to find all the communications about a particular shipment.\n                                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"height":"250"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"large":""}},[_vm._v("place")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Marketplace Analytics")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                                    Understand the marketplace analytics from a single application. Gather rate information on the SPOT shipping market in real-time powered by AI and Machine Learning.\n                                ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent",attrs:{"height":"250"}},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-icon',{staticClass:"blue--text text--lighten-2",attrs:{"large":""}},[_vm._v("email")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Eliminate Email")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                                    Kangaruu unifies your shipping communications. Manage your brokers, freight quotes and communications all in one place in a persistent organized manner.\n                                ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('h2',{staticClass:"headline"},[_vm._v("What the Industry is Saying:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"Traditional 3PLs will not only survive the new digitial brokers, but they will get their pick of platforms.\"\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"https://www.freightwaves.com/news/digital-brokerage-bubble-will-pop-soon","target":"_blank","rel":"noopener"}},[_vm._v("FreightWaves")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"Opportunity may come knocking for freight brokers in 2018, if they adapt to the technological changes going on in trucking.\"\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"http://www.trucker.com/business/where-freight-brokers-can-benefit","target":"_blank","rel":"noopener"}},[_vm._v("American Trucker")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"Freight brokerages generated an estimated $40 billion in revenue last year. The human touch aspect of the freight broker business is something that cannot be replaced by technology alone.\"\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"http://amtransportonline.com/future-freight-freight-brokers-fit/","target":"_blank","rel":"noopener"}},[_vm._v("AM Transport")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"The emergence of Uber-style transactions in the freight industry will not replace brokers.\"\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"http://www.ttnews.com/articles/will-uber-replace-freight-brokers-absolutely-not-tech-expert-insists","target":"_blank","rel":"noopener"}},[_vm._v("Roger Gilroy- Transport Topics")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"The 'Ubers of trucking' pride themselves on being highly automated, and have downplayed the role of humans in our industry. While automation can increase efficiency and drive down costs, transportation is still an industry built on relationships.\"\n\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"https://www.loaddelivered.com/articles/5-lies-the-ubers-of-trucking-may-tell/","target":"_blank","rel":"noopener"}},[_vm._v("Load Delivered")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',[_vm._v("\n                                \"Shippers, Brokers, and Carriers all suffer from extreme lack of modern technology. The entire industry is run on archaic 15+ year old software, almost no data is captured, and none of the software systems can communicate with each other.\"\n\n                            ")]),_vm._v(" "),_c('v-card-text',[_c('a',{attrs:{"href":"https://techcrunch.com/2016/11/02/the-present-and-future-of-trucking-our-countrys-broken-inefficient-economic-backbone/","target":"_blank"}},[_c('a',{attrs:{"href":"https://8vc.com/","target":"_blank","rel":"noopener"}},[_vm._v("8VC - ")]),_vm._v(" Jake Medwell")])])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-parallax',{attrs:{"src":"static/section.jpg","height":"380","alt":"ocean"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"headline white--text mb-3 text-xs-center"},[_vm._v("Managing freight rates on the Spot market has never been easier")]),_vm._v(" "),_c('em',[_vm._v("Digitize your shipping program today")]),_vm._v(" "),_c('v-btn',{staticClass:"blue lighten-2 mt-5",attrs:{"dark":"","large":"","href":"/signup"}},[_vm._v("\n                    Get Started For Free\n                ")])],1)],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","align-content-center":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Messages")])]),_vm._v(" "),_c('img',{staticClass:"resize",attrs:{"src":"static/message.png"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","offset-sm1":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Quotes")])]),_vm._v(" "),_c('img',{staticClass:"resize",attrs:{"src":"static/broker.png"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('section',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{staticClass:"my-5",attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Company info")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                            Kangaruu was formed by technology and industry experts in 2018 to digitize the trucking industry. Kangaruu uses the latest cloud technologies, artificial intelligence and blockchain to create an amazing user experience.\n                            "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.address}},[_vm._v(_vm._s(_vm.addressText))])])],1)],1)],1)],1)],1)])}
var staticRenderFns = []


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewImages_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a85a9a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewImages_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
function injectStyle (context) {
  __webpack_require__(363)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewImages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a85a9a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewImages_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a85a9a8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewImages_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"teal"},nativeOn:{"click":function($event){return _vm.downLoadFile($event)}}},[_c('v-icon',[_vm._v("get_app")])],1),_vm._v(" "),(_vm.isBroker)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"teal"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'brokerfreight', params: { shipmentID: _vm.freightID } })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1):_vm._e(),_vm._v(" "),(!_vm.isBroker)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"teal"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'shipperfreight', params: { shipmentID: _vm.freightID } })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"image-frame"},[_c('object',{attrs:{"data":_vm.imageURL,"type":"application/pdf","width":"100%","height":"100%"}},[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.imageURL,"width":"100%","height":"100%"}},[_vm._v("\n                This browser does not support PDFs. Please download the PDF to view it:\n                "),_c('a',{attrs:{"href":_vm.imageURL}},[_vm._v("Download PDF")])])])])],1)}
var staticRenderFns = []


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93a6df98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error404_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93a6df98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93a6df98_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error404_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title has-text-centered"},[_vm._v("404 Page Missing")]),_vm._v(" "),_c('article',{staticClass:"notification is-danger"},[_c('p',[_vm._v("Sorry, we can't seem to find the page you are looking for.")])])])}]


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af17a23_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(1);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af17a23_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1af17a23_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"dense":"","fixed":""}},[_c('v-btn',{staticClass:"teal--text darken-2",attrs:{"router":"","flat":"","to":"/viewfreight"}},[_vm._v("Kangaruu")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"teal"},nativeOn:{"click":function($event){_vm.$router.push({ name: 'viewfreight' })}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',[_c('v-card-text',[_c('timeline',{attrs:{"id":'KangaruuFreight',"sourceType":'profile',"options":{ tweetLimit: '25' }}})],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[228]);


// WEBPACK FOOTER //
// static/js/app.e91fc808246ad250bbe3.js